// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:38:50.655Z
// Property: Cimarron Trails Apts. (ID: 6767906449165595)
// Collections: 22 amenities, 5 floorplans (live), 17 photos, 76 POIs, 3 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165595",
  "property_external_id": "zjt6m0z",
  "property_zillow_url": "https://www.zillow.com/apartments/norman-ok/cimarron-trails-apts./5XrzkJ/",
  "property_apartments_url": "https://www.apartments.com/cimarron-trails-apts-norman-ok/zjt6m0z/",
  "property_google_business_url": "https://www.google.com/maps/place/Cimarron+Trails+Apartments/data=!4m2!3m1!1s0x0:0xba0898f07193bbf6?sa=X&ved=2ahUKEwiViPu49bySAxU9le4BHQoQOGMQ_BJ6BAg2EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cimarron-trails-apts.",
  "property_name": "Cimarron Trails Apts.",
  "property_website_url": "https://www.caseusa.com/apartments/ok/norman/cimarron-trails/",
  "property_domain": null,
  "property_address": "3100 Rock Creek Trail",
  "property_full_address": "3100 Rock Creek Trail, Norman, OK, 73072",
  "property_address_1": "3100 Rock Creek Trail",
  "property_address_2": null,
  "property_address_city": "Norman",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73072",
  "property_address_country": "US",
  "property_address_county": "Cleveland County",
  "property_neighborhood_address": "Outer Norman",
  "property_address_latitude": "35.2466",
  "property_address_longitude": "-97.4871",
  "property_email": "cimarrontrails@caseusa.com",
  "property_phone": "(405) 972-3513",
  "property_call_tracking_phone": "833-707-2101",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Cimarron Trails Apartments in Norman, Oklahoma, where comfort meets convenience. Choose from thoughtfully designed one, two, or three-bedroom floor plans and enjoy amenities like a refreshing pool, tennis court, and scenic walking trails. Elevate your lifestyle—find your new home today and schedule a tour! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Cimarron Trails Apartments, where comfort meets convenience in the heart of Norman, Oklahoma! Offering a selection of spacious one, two, and three-bedroom floor plans, our community is designed to cater to your lifestyle. Whether you’re a young professional, a growing family, or anyone in between, you'll find the perfect space to call home.\n\nOur thoughtfully designed apartments feature modern amenities, including air conditioning, ceiling fans, and washer/dryer hookups. Enjoy the convenience of high-speed internet access, cable-ready units, and well-appointed kitchens complete with dishwashers and refrigerators. Many apartments also offer charming balconies or patios, perfect for unwinding after a long day.\n\nCimarron Trails is packed with amenities to enhance your living experience. Dive into our refreshing pool, take advantage of our on-site laundry facilities, or grill up a feast in our designated barbecue area. For active residents, we offer tennis courts and scenic walking and biking trails, while our picnic area provides a serene spot for gatherings. With 24-hour access and on-site maintenance and property management, you can relax knowing that everything you need is just a few steps away.\n\nExperience a smoke-free environment in a community that prioritizes your comfort. Ready to make Cimarron Trails Apartments your new home? Browse our availability or schedule a tour today to discover all that our vibrant community has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3e-252d-75de-894e-3dbbdda4b34a.webp",
  "property_featured_image_media": {
    "alt_text": "Cimarron Trails Apartments monument sign with landscaping.",
    "public_id": "019cfb3e-252d-75de-894e-3dbbdda4b34a",
    "storage_key": "property/6767906449165595/019cfb3e-252d-75de-894e-3dbbdda4b34a.webp",
    "width": 2700,
    "height": 1800
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "228",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.24561403508771",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed and Weight Restrictions",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://cimarrontrailsapartmentsnorman.securecafe.com/onlineleasing/cimarron-trails-apts/floorplans.aspx",
  "property_resident_portal_url": "https://cimarrontrailsapartmentsnorman.securecafe.com/residentservices/cimarron-trails-apts/userlogin.aspx",
  "property_apply_now_url": "https://cimarrontrailsapartmentsnorman.securecafe.com/onlineleasing/cimarron-trails-apts/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3c-dc82-70ef-be89-6ae0ab72a87b.webp",
  "property_primary_logo_media": {
    "alt_text": "Cimarron Trails Apartments logo",
    "public_id": "019cfb3c-dc82-70ef-be89-6ae0ab72a87b",
    "storage_key": "property/6767906449165595/019cfb3c-dc82-70ef-be89-6ae0ab72a87b.webp",
    "width": 714,
    "height": 270
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3e-0ce0-745a-8d0b-03dbd93fd0ed.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3e-0ce0-745a-8d0b-03dbd93fd0ed",
    "storage_key": "property/6767906449165595/019cfb3e-0ce0-745a-8d0b-03dbd93fd0ed.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3e-4e99-707f-bd07-8efc6670eded.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cimarron Trails Apartments logo",
    "public_id": "019cfb3e-4e99-707f-bd07-8efc6670eded",
    "storage_key": "property/6767906449165595/019cfb3e-4e99-707f-bd07-8efc6670eded.webp",
    "width": 640,
    "height": 242
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3e-63f2-755c-baf1-b608d5db569a.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cimarron Trails Apartments logo.",
    "public_id": "019cfb3e-63f2-755c-baf1-b608d5db569a",
    "storage_key": "property/6767906449165595/019cfb3e-63f2-755c-baf1-b608d5db569a.webp",
    "width": 640,
    "height": 242
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#3f4040",
  "property_secondary_color": "#a6a8ab",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#85594f",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2.5",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2.5",
  "property_sqft_range": "550 - 1160",
  "property_sqft_min": "550",
  "property_sqft_max": "1160",
  "property_price_range": "909 - 1309",
  "property_price_min": "909",
  "property_price_max": "1309",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/CimarronTrailsNorman/",
  "property_instagram_url": "https://www.instagram.com/cimarrontrailsnorman/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJHeps8X1psocR9ruTcfCYCLo",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/cimarron-trails-apartments-norman-2",
  "property_tiktok_url": "https://www.tiktok.com/@cimtrails?lang=en",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cimarron Trails Apts.",
  "property_home_romance_title": "Embrace a Life of Luxury in Your Dream Apartment Community",
  "property_home_amenities_blurb": "Welcome to Cimarron Trails Apts. in Norman, OK, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans while enjoying premium amenities like a refreshing pool, on-site maintenance, and scenic walking trails. Elevate your lifestyle with us—your dream home awaits!",
  "property_home_floorplans_blurb": "Welcome to Cimarron Trails Apts. in Norman, Oklahoma, where comfort meets style. Choose from spacious one, two, or three-bedroom floor plans designed for modern living. Each apartment is a canvas for your lifestyle. Browse our available homes today and unlock the door to your ideal living space!",
  "property_home_gallery_blurb": "At Cimarron Trails Apts. in Norman, Oklahoma, a vibrant lifestyle awaits! Choose from spacious one to three-bedroom floor plans, and relish in amenities like a sparkling pool, tennis court, and scenic walking trails. Picture yourself enjoying cozy evenings by the fireplace, or grilling with friends on your private balcony!",
  "property_home_neighborhood_blurb": "Welcome to Cimarron Trails Apts. in Norman, Oklahoma, where your new home is surrounded by quality education and vibrant community life. Choose from spacious one, two, or three-bedroom floor plans, all just moments away from the University of Oklahoma, OU Health Sciences Center, and top-rated schools. Uncover local favorites and nearby attractions!",
  "property_home_reviews_blurb": "At Cimarron Trails Apts. in Norman, residents praise our \"wonderful experience\" and quick maintenance services. Nestled near shopping and minutes from I-35, our community offers a clean, quiet environment, complete with multiple pools and pet-friendly policies. See what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "At Cimarron Trails Apartments in Norman, Oklahoma, you'll find a vibrant community nestled near key educational institutions such as the University of Oklahoma and OU Health Sciences Center. With cozy one, two, and three-bedroom floor plans, discover a perfect home while being close to schools like Norman North High School and community resources. See what's around our community and explore local favorites and nearby points of interest.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cimarron Trails Apts. in Norman, Oklahoma, enjoy a harmonious blend of relaxation and lifestyle. Dive into our sparkling pool, unwind at the tennis court, or savor a picnic in the fresh air. With inviting one, two, and three-bedroom layouts, comfort and convenience await right at your doorstep.",
  "property_applynow_blurb": "Welcome to Cimarron Trails Apts. in Norman, Oklahoma, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans adorned with modern amenities. Enjoy a refreshing dip in the pool, unwind by the grill, or explore scenic walking trails. Lease your perfect home online today!",
  "property_contactus_blurb": "At Cimarron Trails Apts. in Norman, Oklahoma, choose from stylish one, two, or three-bedroom floor plans tailored to your lifestyle. Each home offers modern comforts and a vibrant community atmosphere. Have questions? Reach out to our leasing team today and find the perfect space for you!",
  "property_faqs_blurb": "At Cimarron Trails Apts. in Norman, Oklahoma, enjoy spacious one, two, and three-bedroom floor plans designed for comfort and style. Have questions? Our FAQs page holds the answers you seek about community living, amenities, and more. Dive in to learn how Cimarron Trails can be your next home!",
  "property_floorplans_blurb": "At Cimarron Trails Apts. in vibrant Norman, Oklahoma, your ideal living space awaits. With thoughtfully designed one, two, and three-bedroom floor plans, each home offers a unique blend of comfort and style. Browse our available apartments and uncover the perfect fit for your lifestyle today!",
  "property_gallery_blurb": "At Cimarron Trails Apts. in Norman, Oklahoma, vibrant living awaits you. Imagine cozy evenings by the fireplace, refreshing dips in the pool, and weekends spent on biking trails. Our thoughtfully designed one, two, and three-bedroom floor plans complement a lifestyle filled with relaxation and adventure. Picture yourself living here!",
  "property_interactivemap_blurb": "At Cimarron Trails Apts. in Norman, Oklahoma, you’ll find the perfect blend of comfort and convenience. Choose from spacious one, two, or three-bedroom floor plans, and enjoy amenities like a refreshing pool, tennis courts, and scenic walking trails. Use our interactive community map to explore your future home today!",
  "property_pets_blurb": "At Cimarron Trails Apartments in Norman, OK, your furry friends are part of the family! With a welcoming pet policy and beautifully landscaped surroundings, our community is perfect for both you and your four-legged companions. Experience comfort, convenience, and the joy of living together—schedule your visit today!",
  "property_referafriend_blurb": "At Cimarron Trails Apts. in Norman, Oklahoma, we believe great friends make great neighbors! Choose from our thoughtfully designed one, two, and three-bedroom floor plans to find your perfect fit. Refer a friend today and enjoy the vibrant community that awaits you! Your new home is just a referral away!",
  "property_residentaccess_blurb": "At Cimarron Trails Apts. in Norman, Oklahoma, our diverse floor plans cater to every lifestyle. Whether you seek a cozy one-bedroom or a spacious three-bedroom, comfortable living is just a click away. Access your resident portal for seamless rent payments, maintenance requests, and essential community updates today!",
  "property_reviews_blurb": "At Cimarron Trails Apts. in Norman, Oklahoma, residents rave about the \"wonderful experience\" of touring the community at their own pace. With a clean, pet-friendly environment and quick maintenance, it’s no wonder why so many love calling this tranquil haven home. See what our residents have to say about living at our community!",
  "property_created_at": "1753982380994",
  "property_scheduletour_blurb": "At Cimarron Trails Apts. in Norman, Oklahoma, you'll find thoughtfully designed one, two, and three-bedroom floor plans that complement your lifestyle. Schedule a tour today, and hear firsthand what makes our community a cherished home for residents who love comfort, convenience, and a vibrant neighborhood atmosphere!",
  "property_thankyou_blurb": "Thank you for reaching out to Cimarron Trails Apts. in Norman, Oklahoma! Our community offers spacious one, two, and three-bedroom floor plans designed to elevate your living experience. A team member will connect with you soon to assist in finding your perfect home. Stay tuned for exciting updates!",
  "property_virtualtours_blurb": "Welcome to Cimarron Trails Apts. in Norman, Oklahoma, where contemporary design meets comfort. With thoughtfully designed one, two, and three-bedroom floor plans, your ideal home awaits. Ready to envision your life here? Take a virtual tour and step into a vibrant community tailored just for you!",
  "property_copyright": "2025 All Rights Reserved. Cimarron Trails Apts.",
  "property_seo_title_home": "Cimarron Trails Apts. |  Apartments in Norman, Oklahoma",
  "property_seo_description_home": "Discover comfort at Cimarron Trails Apts. in Norman, OK. Choose one to three-bedroom homes with top amenities. Your new life awaits!",
  "property_seo_title_floorplans": "Floor Plans | Norman, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Cimarron Trails Apts. in Norman, OK! Choose from one, two, or three-bedroom floor plans designed for your comfort and style.",
  "property_seo_title_amenities": "Amenities | Norman, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Discover Cimarron Trails Apartments in Norman—enjoy a vibrant community with a pool, trails, and spacious floor plans!",
  "property_seo_title_gallery": "Gallery | Apartments in Norman, Oklahoma",
  "property_seo_description_gallery": "Experience your ideal life at Cimarron Trails Apts. in Norman, OK! Enjoy spacious layouts, resort-style amenities, and lush green spaces.",
  "property_seo_title_virtualtours": "Virtual Tours | Cimarron Trails Apts. Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Cimarron Trails Apts. in Norman, OK. Take a virtual tour of our inviting one, two, and three-bedroom homes today!",
  "property_seo_title_interactivemap": "Interactive Map | Cimarron Trails Apts. Apartments",
  "property_seo_description_interactivemap": "Find your perfect fit at Cimarron Trails Apts. in Norman, OK! Check our interactive map for one to three-bedroom apartments with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Norman, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Norman at Cimarron Trails Apts! Dive into local favorites and must-see spots near our vibrant community. Your adventure awaits!",
  "property_seo_title_contact": "Contact Us | Cimarron Trails Apts.",
  "property_seo_description_contact": "Connect with Cimarron Trails Apts. in Norman, OK! From cozy one to spacious three-bedroom layouts, our team is here to assist. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Norman, Oklahoma",
  "property_seo_description_faqs": "Discover answers at Cimarron Trails Apts in Norman, OK! Enjoy a pool, trails, and spacious layouts. Join our community today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Norman, Oklahoma",
  "property_seo_description_reviews": "Experience life at Cimarron Trails Apts. in Norman, OK. Read resident reviews to see how our vibrant community and amenities enhance your lifestyle!",
  "property_seo_title_applynow": "Apply Now | Apartments in Norman, Oklahoma",
  "property_seo_description_applynow": "Cimarron Trails Apts in Norman, OK offers modern living with spacious layouts and premium amenities. Apply online today for your perfect home!",
  "property_seo_title_residentaccess": "Resident Access | Cimarron Trails Apts.",
  "property_seo_description_residentaccess": "Access the Cimarron Trails Apts. portal for easy rent payments, maintenance requests, and a seamless living experience.",
  "property_seo_title_referafriend": "Refer A Friend | Cimarron Trails Apts.",
  "property_seo_description_referafriend": "Refer a friend to Cimarron Trails Apts in Norman, OK! Great friends make great neighbors—share the perks of living in our vibrant community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cimarron Trails Apts.",
  "property_seo_description_scheduletour": "Experience the charm of Cimarron Trails Apts. in Norman, OK. Schedule a tour today and envision your new life in this vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Cimarron Trails Apts.",
  "property_seo_description_privacy": "Your privacy matters at Cimarron Trails Apts. in Norman, OK. Learn about our commitment to data protection and view our privacy policy.",
  "property_seo_title_accessibility": "Website Accessibility | Cimarron Trails Apts.",
  "property_seo_description_accessibility": "Cimarron Trails Apts. in Norman, OK champions digital inclusion with accessible solutions for all. Experience comfortable living designed for everyone!",
  "property_seo_title_sitemap": "Sitemap | Cimarron Trails Apts.",
  "property_seo_description_sitemap": "Navigate your way through Cimarron Trails Apts' website sitemap. Find your perfect home in Norman, Oklahoma, and start your journey today!",
  "property_seo_title_thankyou": "Thank You | Cimarron Trails Apts.",
  "property_seo_description_thankyou": "Thank you for reaching out to Cimarron Trails Apts in Norman, OK! Our team will connect with you soon to help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Norman, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787865017520",
  "amenities": [
    {
      "id": "ec_1bf9f078bedf955bb755e8f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127396390",
      "title": "Carport",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6df46256fd25929ae4a56414",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127396391",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88bfb13cee68da5aae70ab58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127396394",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80e731f429c1b9c6ea4ce2c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127396395",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_964b1458c2f83175e4f3f3de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127396396",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_80695e3e943ab01afd017322",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127396397",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b85db215d3055b20ff5c91a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127396398",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cda8e22da5ad3555ea0a3acd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127396399",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1ee2190d29d60cde37ad76f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127396400",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39fb0490fd98dc890da77406",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127396401",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e4baece90fb458bacc2d5c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "128017277",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_26f19a82170a6bb1e59bd6c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127397886",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc8e4d616d53bc79774d9827",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127397887",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_100600f6c14ca22b0d9bc2cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127397888",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f0514ee2f2e909016b8b9c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127397889",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df766034f90dbc47ba6d945b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127397890",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca7df3fcc39cd94bad207982",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127397891",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e7e5c90b7a4e51c4a50a6cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127397892",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_739c501ac24e0b801a095fc9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127397893",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3af82a214db7659597f36be9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127397894",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ad5288688238d97bdbd93fb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127397895",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa2e052ae1da3f4fb9fbd961",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "yardi",
      "external_id": "127397896",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_908778b0-8e97-46c8-8d60-7a470d0a2c9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-7a1c-70c2-9f60-3e18e9dcd14d.webp",
      "image_media": {
        "alt_text": "A laundry room with a row of washers and dryers.",
        "public_id": "019d2708-7a1c-70c2-9f60-3e18e9dcd14d",
        "storage_key": "property/6767906449165595/019d2708-7a1c-70c2-9f60-3e18e9dcd14d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with washers and dryers for resident use.",
      "link": "",
      "alt_text": "A laundry room with a row of washers and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165595/019cfb3c-3637-744f-b480-7bdeeb3de025.webp"
    },
    {
      "id": "custom_ed1fb7df-1744-41b0-9bd5-929a92d6a6df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-7ccd-7369-8662-873aead7c9ac.webp",
      "image_media": {
        "alt_text": "Cimarron Trails Apartments monument sign with pink flowering bushes and landscaping.",
        "public_id": "019d2708-7ccd-7369-8662-873aead7c9ac",
        "storage_key": "property/6767906449165595/019d2708-7ccd-7369-8662-873aead7c9ac.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Cimarron Trails Apartments, where comfort and convenience meet. Discover our community's amenities and find your perfect home.",
      "link": "",
      "alt_text": "Cimarron Trails Apartments monument sign with pink flowering bushes and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165595/019cfb3c-48ee-71e4-bb81-c43c2ecbb006.webp"
    },
    {
      "id": "custom_b512361a-fe19-4770-a7a4-5bd38d703a85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-7d54-753e-aade-de2271b64456.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with picnic area and outdoor grill.",
        "public_id": "019d2708-7d54-753e-aade-de2271b64456",
        "storage_key": "property/6767906449165595/019d2708-7d54-753e-aade-de2271b64456.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at the community picnic area, complete with grills and seating, adjacent to the apartment buildings.",
      "link": "",
      "alt_text": "Apartment building exterior with picnic area and outdoor grill.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165595/019cfb3c-4ca8-7164-950a-a2ce8c096c0a.webp"
    },
    {
      "id": "custom_d7953d8a-d2cf-4745-b56e-5d3e6bf08e6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-8be7-73ab-b346-237f7e2ff012.webp",
      "image_media": {
        "alt_text": "A building with a sign that says Cimarron Trails Hearing Centers.",
        "public_id": "019d2708-8be7-73ab-b346-237f7e2ff012",
        "storage_key": "property/6767906449165595/019d2708-8be7-73ab-b346-237f7e2ff012.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to the Cimarron Trails Leasing Center, featuring a well-maintained exterior and convenient self-guided tour options.",
      "link": "",
      "alt_text": "A building with a sign that says Cimarron Trails Hearing Centers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165595/019cfb3c-4ec2-73aa-8c98-1c8392134695.webp"
    },
    {
      "id": "custom_373d7684-d41f-4f13-90f9-0f915d9a9139",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-8fe3-760d-9642-725efc23a4de.webp",
      "image_media": {
        "alt_text": "Outdoor grilling and dining area with built-in grills, fireplace, picnic tables, and umbrellas.",
        "public_id": "019d2708-8fe3-760d-9642-725efc23a4de",
        "storage_key": "property/6767906449165595/019d2708-8fe3-760d-9642-725efc23a4de.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor gatherings at our community grilling station, featuring built-in grills, a cozy fireplace, and ample seating for residents.",
      "link": "",
      "alt_text": "Outdoor grilling and dining area with built-in grills, fireplace, picnic tables, and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165595/019cfb3c-52a4-70b8-9459-f34962a02792.webp"
    },
    {
      "id": "custom_2430c2e8-ed68-4b44-87ed-2854347fe44b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-8fc9-71e5-912d-4c2baea8b180.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
        "public_id": "019d2708-8fc9-71e5-912d-4c2baea8b180",
        "storage_key": "property/6767906449165595/019d2708-8fc9-71e5-912d-4c2baea8b180.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing on sunny days.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, adjacent to apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165595/019cfb3c-52fe-7037-b594-bf96a4c65fdf.webp"
    },
    {
      "id": "custom_9ad2c946-3ede-4d88-95df-828b1e3372fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-903b-761b-be8c-42f2568cb9b7.webp",
      "image_media": {
        "alt_text": "Community lounge area with a dining table, seating, and a workspace.",
        "public_id": "019d2708-903b-761b-be8c-42f2568cb9b7",
        "storage_key": "property/6767906449165595/019d2708-903b-761b-be8c-42f2568cb9b7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Gather in our inviting community lounge, featuring a stylish dining area and a convenient workspace. Perfect for socializing or getting some work done.",
      "link": "",
      "alt_text": "Community lounge area with a dining table, seating, and a workspace.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165595/019cfb3c-560a-74ba-9fd7-be256bce49b5.webp"
    },
    {
      "id": "custom_4dad0f9d-988f-427a-acc8-0fbdd26549ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-a21f-7172-bbe7-50c6a30d5bc1.webp",
      "image_media": {
        "alt_text": "Comfortable lounge area with a fireplace, seating, and coffee bar.",
        "public_id": "019d2708-a21f-7172-bbe7-50c6a30d5bc1",
        "storage_key": "property/6767906449165595/019d2708-a21f-7172-bbe7-50c6a30d5bc1.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy fireplace and a convenient coffee bar.",
      "link": "",
      "alt_text": "Comfortable lounge area with a fireplace, seating, and coffee bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165595/019cfb3c-5625-7168-b189-551d16b3828e.webp"
    },
    {
      "id": "custom_28117149-d0ca-4c55-b456-d9c1747e5224",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-a528-77f8-af92-7dff279917ff.webp",
      "image_media": {
        "alt_text": "Modern communal dining and workspace area with comfortable seating and decorative art.",
        "public_id": "019d2708-a528-77f8-af92-7dff279917ff",
        "storage_key": "property/6767906449165595/019d2708-a528-77f8-af92-7dff279917ff.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a stylish and functional communal space perfect for working, dining, or relaxing. Features comfortable seating, elegant decor, and a large dining table.",
      "link": "",
      "alt_text": "Modern communal dining and workspace area with comfortable seating and decorative art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165595/019cfb3c-5646-70f2-a660-770e86726074.webp"
    },
    {
      "id": "custom_df0325b5-fcc3-4b9b-a891-ae1ae98910b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019dabe1-3e82-766d-a5ee-edadef884dc4.webp",
      "image_media": {
        "alt_text": "Living room with gray armchair, TV on a wooden cabinet, and glass coffee table.",
        "public_id": "019dabe1-3e82-766d-a5ee-edadef884dc4",
        "storage_key": "property/6767906449165595/019dabe1-3e82-766d-a5ee-edadef884dc4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a comfortable gray armchair, a modern media console with a television, and a stylish glass coffee table, perfect for relaxing.",
      "link": "",
      "alt_text": "Living room with gray armchair, TV on a wooden cabinet, and glass coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c30717c-b904-4b0f-a9e4-f8e0a349b4c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019dabe1-3e26-712f-91f0-d8c5a662f7dd.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-sized bed, nightstand, and ceiling fan.",
        "public_id": "019dabe1-3e26-712f-91f0-d8c5a662f7dd",
        "storage_key": "property/6767906449165595/019dabe1-3e26-712f-91f0-d8c5a662f7dd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-sized bed, elegant nightstand, and a soothing ceiling fan.",
      "link": "",
      "alt_text": "Cozy bedroom with a king-sized bed, nightstand, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_edf74ff7-b43b-4db9-aae6-df947c445361",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019dabe1-3dc1-76ed-9a79-0068d3272fd2.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and access to a bathroom and closet.",
        "public_id": "019dabe1-3dc1-76ed-9a79-0068d3272fd2",
        "storage_key": "property/6767906449165595/019dabe1-3dc1-76ed-9a79-0068d3272fd2.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, elegant decor, and convenient access to an en-suite bathroom and a walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and access to a bathroom and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_50b426c0-290a-459d-a5cf-c96f175e5646",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019dabe1-3ca2-74bf-9f3b-3dd9460cbfe3.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with dark cabinets, stainless steel appliances, and a wooden dining table.",
        "public_id": "019dabe1-3ca2-74bf-9f3b-3dd9460cbfe3",
        "storage_key": "property/6767906449165595/019dabe1-3ca2-74bf-9f3b-3dd9460cbfe3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy convenient living in this apartment kitchen and dining area, featuring ample cabinet space, modern appliances, and a stylish dining set.",
      "link": "",
      "alt_text": "Dining area and kitchen with dark cabinets, stainless steel appliances, and a wooden dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_694656e8-b25d-4e44-94ab-ade498bdbb45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019dabe1-23a7-7080-ad55-90b5fe58404d.webp",
      "image_media": {
        "alt_text": "Cozy living room with plush sofa, armchair, coffee table, and floor lamp.",
        "public_id": "019dabe1-23a7-7080-ad55-90b5fe58404d",
        "storage_key": "property/6767906449165595/019dabe1-23a7-7080-ad55-90b5fe58404d.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Inviting living room featuring a textured sofa, comfortable armchair, and elegant coffee table, perfect for relaxation.",
      "link": "",
      "alt_text": "Cozy living room with plush sofa, armchair, coffee table, and floor lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dca59fc0-d5fe-4cff-8bc5-f31d17250727",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019dabe1-23a6-7371-8f9c-54accd9b0f94.webp",
      "image_media": {
        "alt_text": "Bathroom with a blue shower curtain, toilet, sink, and vanity.",
        "public_id": "019dabe1-23a6-7371-8f9c-54accd9b0f94",
        "storage_key": "property/6767906449165595/019dabe1-23a6-7371-8f9c-54accd9b0f94.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a clean white tub with a blue shower curtain, a toilet, and a vanity with a marble-effect countertop and vessel sink. Decorative wall hangings add a touch of style.",
      "link": "",
      "alt_text": "Bathroom with a blue shower curtain, toilet, sink, and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f33b3a40-56f6-4bdd-bf77-46d347111854",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019dabe1-246a-7377-a5b9-828e0e5976e4.webp",
      "image_media": {
        "alt_text": "A modern bathroom featuring a toilet with blue towels and a vanity with a sink, mirror, and decorative items.",
        "public_id": "019dabe1-246a-7377-a5b9-828e0e5976e4",
        "storage_key": "property/6767906449165595/019dabe1-246a-7377-a5b9-828e0e5976e4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed bathroom, complete with a modern vanity, ample storage, and elegant decor.",
      "link": "",
      "alt_text": "A modern bathroom featuring a toilet with blue towels and a vanity with a sink, mirror, and decorative items.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e572d6b9-8f13-4f5b-871f-6680f8223f68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019dabe1-23a7-7080-ad55-8c6c8703129e.webp",
      "image_media": {
        "alt_text": "Kitchen with dark cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019dabe1-23a7-7080-ad55-8c6c8703129e",
        "storage_key": "property/6767906449165595/019dabe1-23a7-7080-ad55-8c6c8703129e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark cabinetry, granite countertops, and stainless steel appliances, perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with dark cabinets, stainless steel appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_11074e69-c667-4d94-9dd1-2d4cc7acb793",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Tamashii Ramen House- Norman",
      "poi_type": "Restaurants",
      "poi_address": "126 W Main St, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this ramen restaurant serves delicious garlic fried rice, spicy ramen, and tonkotsu ramen. They highlight the flavorful broth, tender chicken, and generous portions. They also like the fun, anime-themed atmosphere and the attentive, friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-e210-74a6-8322-c53707e3e779.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e210-74a6-8322-c53707e3e779",
        "storage_key": "property/6767906449165595/019d2708-e210-74a6-8322-c53707e3e779.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tamashiiokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1400114531233121933&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tamashii-ramen-house--norman",
      "poi_latitude": "35.2199606",
      "poi_longitude": "-97.4448329",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-855-0999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1ce7-7152-afc8-d9387934c5a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1ce7-7152-afc8-d9387934c5a4",
        "storage_key": "property/6767906449165595/019d2709-1ce7-7152-afc8-d9387934c5a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ74AQ9KppsocRjUYDf780bhM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ramen_restaurant"
    },
    {
      "id": "custom_c25364fb-508d-4eb9-963f-7dfdd7c93723",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Tarahumara's Méxican Cafe & Cantina",
      "poi_type": "Restaurants",
      "poi_address": "702 N Porter Ave, Norman, OK 73071, USA",
      "poi_short_description": "Relaxed eatery serving up Mexican standards like tacos, fajitas, burritos and enchiladas, along with margaritas.",
      "poi_long_description": "People say this Mexican restaurant serves delicious chicken fajitas, chips and salsa, and queso. They highlight the generous portions, fast service, and excellent margaritas. They also like the attentive and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-e10c-75aa-a06c-69113500c287.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e10c-75aa-a06c-69113500c287",
        "storage_key": "property/6767906449165595/019d2708-e10c-75aa-a06c-69113500c287.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.tarahumarasmexicancafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=439215236524010818&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tarahumaras-mxican-cafe--cantina",
      "poi_latitude": "35.22780820000001",
      "poi_longitude": "-97.4413034",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-360-8070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1ce7-7152-afc8-d9387934c5a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1ce7-7152-afc8-d9387934c5a4",
        "storage_key": "property/6767906449165595/019d2709-1ce7-7152-afc8-d9387934c5a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtTMsguBpsocRQu3zOO5nGAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_5cd48923-7bc7-4517-aadd-bb5c5839109c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2001 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Fast-food joint known for chicken sandwiches and waffle fries, and offering a kids' menu.",
      "poi_long_description": "People say this fast food restaurant serves chicken sandwiches and cob salads. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-e119-72ba-ade7-d164aa8b86dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e119-72ba-ade7-d164aa8b86dd",
        "storage_key": "property/6767906449165595/019d2708-e119-72ba-ade7-d164aa8b86dd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/moore?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=1304875027432141954&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "35.3186309",
      "poi_longitude": "-97.4951348",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-799-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1ce7-7152-afc8-d9387934c5a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1ce7-7152-afc8-d9387934c5a4",
        "storage_key": "property/6767906449165595/019d2709-1ce7-7152-afc8-d9387934c5a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-8xCoDtrsocRgvRehuzYGxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_1b661aaf-2940-466c-9576-d740a51064bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Neighborhood JAM",
      "poi_type": "Restaurants",
      "poi_address": "102 W Main St, Norman, OK 73069, USA",
      "poi_short_description": "Relaxed breakfast restaurant serving avocado toast, pancakes and other familiar dishes.",
      "poi_long_description": "People say this breakfast restaurant serves delicious biscuits, scrambles, and breakfast tacos. They highlight the well-thought-out menu with many options, and the fresh, hot food. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-e115-71fa-ba34-3b54e04cc913.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e115-71fa-ba34-3b54e04cc913",
        "storage_key": "property/6767906449165595/019d2708-e115-71fa-ba34-3b54e04cc913.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thatsmyjamok.com/locations/norman/",
      "poi_directions_map_url": "https://maps.google.com/?cid=132307001450143405&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "neighborhood-jam",
      "poi_latitude": "35.220375",
      "poi_longitude": "-97.4439773",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-310-2127",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1ce7-7152-afc8-d9387934c5a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1ce7-7152-afc8-d9387934c5a4",
        "storage_key": "property/6767906449165595/019d2709-1ce7-7152-afc8-d9387934c5a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ50SsXCFpsocRrZ67ToQM1gE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_f5815553-f15b-4780-acfa-3be1a1a063fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Cracker Barrel Old Country Store",
      "poi_type": "Restaurants",
      "poi_address": "800 N Interstate Dr, Norman, OK 73072, USA",
      "poi_short_description": "Relaxed outpost dishing up homestyle American eats such as buttermilk pancakes, plus a gift shop.",
      "poi_long_description": "People say this restaurant serves delicious chicken and dumplings, chicken fried steak, and hashbrown casserole. They also highlight the friendly staff, the cozy atmosphere, and the unique shopping experience.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-e7db-705a-98b0-b3fcd09e4917.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e7db-705a-98b0-b3fcd09e4917",
        "storage_key": "property/6767906449165595/019d2708-e7db-705a-98b0-b3fcd09e4917.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.crackerbarrel.com/Locations/States/ok/norman/181/?utm_source=google&utm_medium=maps&utm_campaign=crackerbarrelurl",
      "poi_directions_map_url": "https://maps.google.com/?cid=12360073832655434620&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cracker-barrel-old-country-store",
      "poi_latitude": "35.2284997",
      "poi_longitude": "-97.4867749",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-360-3117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1ce7-7152-afc8-d9387934c5a4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1ce7-7152-afc8-d9387934c5a4",
        "storage_key": "property/6767906449165595/019d2709-1ce7-7152-afc8-d9387934c5a4.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl6kFdnRpsocRfDMHEarNh6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_ae0a56c5-4424-41b7-b598-05169f22bf20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Sooner Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "3301 W Main St, Norman, OK 73072, USA",
      "poi_short_description": "Enclosed mall featuring apparel and sporting goods stores, a food court, and a playground.",
      "poi_long_description": "Covered complex for shopping & dining plus a trampoline park & virtual reality experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-e8af-721e-af61-9c2af6531579.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e8af-721e-af61-9c2af6531579",
        "storage_key": "property/6767906449165595/019d2708-e8af-721e-af61-9c2af6531579.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.soonermall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7755349768317849569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sooner-mall",
      "poi_latitude": "35.2200122",
      "poi_longitude": "-97.4907714",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-360-0341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1ce0-71ea-8f5b-fb8ae9219403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1ce0-71ea-8f5b-fb8ae9219403",
        "storage_key": "property/6767906449165595/019d2709-1ce0-71ea-8f5b-fb8ae9219403.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJH3uVDQ5psocR4U9-UYaJoGs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_02e54afa-ff71-4ea7-9b2f-b73e80bf42a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "2555 Hemphill Dr, Norman, OK 73069, USA",
      "poi_short_description": "Chain supplying home-improvement materials, appliances, paint, and patio furniture, plus lawn-equipment rental.",
      "poi_long_description": "People say this home improvement store offers a wide variety of products. They also highlight the helpful staff and quick and easy pick-up service.\n\nOther reviews mention the inventory can be inaccurate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-e709-72ed-b577-6045851db49b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e709-72ed-b577-6045851db49b",
        "storage_key": "property/6767906449165595/019d2708-e709-72ed-b577-6045851db49b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Norman/1165?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1165-_-na-_-0-_-0&y_source=1_MTE4MzI1MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16039383829879335227&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "35.224972",
      "poi_longitude": "-97.481412",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-329-2009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1ce0-71ea-8f5b-fb8ae9219403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1ce0-71ea-8f5b-fb8ae9219403",
        "storage_key": "property/6767906449165595/019d2709-1ce0-71ea-8f5b-fb8ae9219403.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi62bmwppsocROyka7JxWl94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_86c56ded-b714-401c-be59-3479cb928879",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "850 Ed Noble Pkwy, Norman, OK 73072, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has helpful and knowledgeable staff who are always willing to assist customers with their projects. They also highlight the well-stocked inventory, with a wide variety of items for both personal and professional needs.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-e91f-732e-b23a-35e84cf8eb83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e91f-732e-b23a-35e84cf8eb83",
        "storage_key": "property/6767906449165595/019d2708-e91f-732e-b23a-35e84cf8eb83.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Norman/OK/Norman/73072/3906?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=2554053834785429710&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.2082106",
      "poi_longitude": "-97.4836927",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-579-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1ce0-71ea-8f5b-fb8ae9219403.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1ce0-71ea-8f5b-fb8ae9219403",
        "storage_key": "property/6767906449165595/019d2709-1ce0-71ea-8f5b-fb8ae9219403.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVXAm0wBpsocRzhicR27ScSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_008cef89-8fe5-4172-8d74-0ccc713cde9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "755 SW 19th St, Moore, OK 73160, USA",
      "poi_short_description": "Grocery store stocking bulk items, organic products, and prepared foods, plus a deli and a bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of bulk foods, including spices, nuts, seeds, flours, and baking needs, as well as a large selection of candy, coffee, and pizza. They highlight the great prices, especially on bulk items, and the clean, well-stocked store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-ec83-72d1-9674-e7b27d88ddf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ec83-72d1-9674-e7b27d88ddf4",
        "storage_key": "property/6767906449165595/019d2708-ec83-72d1-9674-e7b27d88ddf4.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16116728468117303121&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "35.3211875",
      "poi_longitude": "-97.501428",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-759-6329",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1cba-7021-89de-3ea57b8d8c12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1cba-7021-89de-3ea57b8d8c12",
        "storage_key": "property/6767906449165595/019d2709-1cba-7021-89de-3ea57b8d8c12.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGQsfeThrsocRUa-O0yYfqt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_0f7aa866-ce31-477e-ad36-c6ac09cf81bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Crest Fresh Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2550 Mt Williams Dr, Norman, OK 73069, USA",
      "poi_short_description": "Vast, 24/7, chain offering groceries ranging from the basics to gourmet fare, plus bakery items and deli treats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-ed56-70da-96fd-8597402d79e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ed56-70da-96fd-8597402d79e6",
        "storage_key": "property/6767906449165595/019d2708-ed56-70da-96fd-8597402d79e6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1924302074676916156&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-fresh-market",
      "poi_latitude": "35.2375928",
      "poi_longitude": "-97.4791021",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-809-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1cba-7021-89de-3ea57b8d8c12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1cba-7021-89de-3ea57b8d8c12",
        "storage_key": "property/6767906449165595/019d2709-1cba-7021-89de-3ea57b8d8c12.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3ZuH6IJpsocRvC-qoYp-tBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b27dd47b-3670-4e5a-b5c7-ca30cb325183",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "The University of Oklahoma",
      "poi_type": "Education",
      "poi_address": "660 Parrington Oval, Norman, OK 73019, USA",
      "poi_short_description": "Founded in 1890, this research school is home to a sprawling museum dedicated to natural history.",
      "poi_long_description": "Founded in 1890, this research school is home to a sprawling museum dedicated to natural history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-eecb-7146-b3d9-0ed75c36a0dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-eecb-7146-b3d9-0ed75c36a0dc",
        "storage_key": "property/6767906449165595/019d2708-eecb-7146-b3d9-0ed75c36a0dc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5385970366617493076&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-university-of-oklahoma",
      "poi_latitude": "35.1987162",
      "poi_longitude": "-97.4448963",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-325-0311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1c8d-7409-ab9c-e23c1bd6556c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1c8d-7409-ab9c-e23c1bd6556c",
        "storage_key": "property/6767906449165595/019d2709-1c8d-7409-ab9c-e23c1bd6556c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJu1B_5itosocRVB4EKYPPvko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_92306428-2652-434f-8e03-293ed6893c51",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Pioneer Library System - Moore Public Library",
      "poi_type": "Education",
      "poi_address": "225 S Howard Ave, Moore, OK 73160, USA",
      "poi_short_description": "Local institution that provides books, DVDs, computers and programs, with an emphasis on children's offerings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-f056-726a-a1e6-f2b585400db1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f056-726a-a1e6-f2b585400db1",
        "storage_key": "property/6767906449165595/019d2708-f056-726a-a1e6-f2b585400db1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pioneerlibrarysystem.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13566280005030728682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-library-system---moore-public-library",
      "poi_latitude": "35.3358205",
      "poi_longitude": "-97.4885841",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-793-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-2102-70b8-ba2f-46a4b28df070.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-2102-70b8-ba2f-46a4b28df070",
        "storage_key": "property/6767906449165595/019d2709-2102-70b8-ba2f-46a4b28df070.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0xg3BdMUsocR6lNXj8kbRbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_6d290130-8e31-4eb7-8f8c-d37cd32c0f20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Bizzell Memorial Library",
      "poi_type": "Education",
      "poi_address": "Bizzell Memorial Library, 401 W Brooks St, Norman, OK 73019, USA",
      "poi_short_description": "Handsome academic institution boasting 8 floors of books and meeting spaces, plus a coffee shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-f22e-77fc-93df-12e124c9392e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f22e-77fc-93df-12e124c9392e",
        "storage_key": "property/6767906449165595/019d2708-f22e-77fc-93df-12e124c9392e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://libraries.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12214855868594969836&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bizzell-memorial-library",
      "poi_latitude": "35.2080168",
      "poi_longitude": "-97.4456785",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-325-3341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-2102-70b8-ba2f-46a4b28df070.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-2102-70b8-ba2f-46a4b28df070",
        "storage_key": "property/6767906449165595/019d2709-2102-70b8-ba2f-46a4b28df070.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv2Nnk39CsocR7NwyBrLig6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_e764f42e-653d-4f74-a88b-bc286fab3340",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Randall University",
      "poi_type": "Education",
      "poi_address": "3701 S I-35 Service Rd, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-f477-72ee-a830-660af7400bef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f477-72ee-a830-660af7400bef",
        "storage_key": "property/6767906449165595/019d2708-f477-72ee-a830-660af7400bef.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.ru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1911580702336403596&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "randall-university",
      "poi_latitude": "35.300769",
      "poi_longitude": "-97.491047",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-912-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1c8d-7409-ab9c-e23c1bd6556c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1c8d-7409-ab9c-e23c1bd6556c",
        "storage_key": "property/6767906449165595/019d2709-1c8d-7409-ab9c-e23c1bd6556c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ7VS3UoQWsocRjMhAUoVMhxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_50907670-08a8-453f-b559-f1c2a4c270f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Pioneer Library System - Norman Public Library East",
      "poi_type": "Education",
      "poi_address": "3051 E Alameda St, Norman, OK 73071, USA",
      "poi_short_description": "Neighborhood branch of the public library system offers books and computer access, plus 3D printers.",
      "poi_long_description": "People say this public library has a wonderful children's area and helpful staff. They also highlight the clean, tidy, and cozy space with beautiful views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-f40a-75b4-b6c2-a23f4a40dc9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f40a-75b4-b6c2-a23f4a40dc9e",
        "storage_key": "property/6767906449165595/019d2708-f40a-75b4-b6c2-a23f4a40dc9e.webp",
        "width": 1280,
        "height": 1028
      },
      "poi_business_url": "https://www.pioneerlibrarysystem.org/choose-a-library/norman-east",
      "poi_directions_map_url": "https://maps.google.com/?cid=17936631778263869986&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-library-system---norman-public-library-east",
      "poi_latitude": "35.2186547",
      "poi_longitude": "-97.3958326",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-217-0770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1c8d-7409-ab9c-e23c1bd6556c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1c8d-7409-ab9c-e23c1bd6556c",
        "storage_key": "property/6767906449165595/019d2709-1c8d-7409-ab9c-e23c1bd6556c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_-ry_DRDsocRIqpm6pG36_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_3d98f018-2fa5-40fa-8192-d54941adef6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Lloyd Noble Center",
      "poi_type": "Entertainment",
      "poi_address": "2900 S Jenkins Ave, Norman, OK 73019, USA",
      "poi_short_description": "Host for Sooner basketball games and women's gymnastics events.",
      "poi_long_description": "People say this arena offers a great atmosphere for watching college basketball games and epic graduation ceremonies. They also highlight the clean facilities, comfortable seating, and easy access with plenty of parking.\n\nOther reviews mention the seats can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-f57c-7482-b7fc-e4bfe479cb9b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f57c-7482-b7fc-e4bfe479cb9b",
        "storage_key": "property/6767906449165595/019d2708-f57c-7482-b7fc-e4bfe479cb9b.webp",
        "width": 1280,
        "height": 772
      },
      "poi_business_url": "http://lloydnoblecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14422888574861973776&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lloyd-noble-center",
      "poi_latitude": "35.18733",
      "poi_longitude": "-97.444262",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-325-4666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21a4-74db-85b8-362849c7d69d",
        "storage_key": "property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ_v3ECFosocREBmwO75kKMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_c4c53393-6b96-4c8a-98f1-5a340a3e4ecb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Gaylord Family - Oklahoma Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1185 Asp Ave, Norman, OK 73019, USA",
      "poi_short_description": "Stadium for Oklahoma University's football team, set on campus.",
      "poi_long_description": "People say this stadium offers a fun, exciting, and intense college football experience. They highlight the electric atmosphere, energetic crowd, and the easy access to restrooms and food options. They also like the welcoming and delightful staff and environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-f7af-74c3-95d1-0745cbd91803.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f7af-74c3-95d1-0745cbd91803",
        "storage_key": "property/6767906449165595/019d2708-f7af-74c3-95d1-0745cbd91803.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://soonersports.com/ViewArticle.dbml?&DB_OEM_ID=31000&ATCLID=208803887",
      "poi_directions_map_url": "https://maps.google.com/?cid=1926763231009947154&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gaylord-family---oklahoma-memorial-stadium",
      "poi_latitude": "35.2058537",
      "poi_longitude": "-97.4423145",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-325-2424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-20fd-7488-91d2-8dc97920bb73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-20fd-7488-91d2-8dc97920bb73",
        "storage_key": "property/6767906449165595/019d2709-20fd-7488-91d2-8dc97920bb73.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUWBFtdRpsocREr6hPvM8vRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_69338d59-9142-44ba-bd21-8dae5da4c628",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Sam Noble Oklahoma Museum of Natural History",
      "poi_type": "Entertainment",
      "poi_address": "2401 Chautauqua Ave, Norman, OK 73072, USA",
      "poi_short_description": "Permanent and rotating displays of dinosaur bones, artifacts and interactive exhibits.",
      "poi_long_description": "Visitors say this natural history museum features a variety of dinosaur exhibits, including fossils found in Oklahoma and the Guinness Book of World Record exhibit for the largest single dinosaur ever found. They also highlight the museum's hands-on learning experiences, immersive displays, and rotating exhibits, making it a great place for families, students, and dinosaur enthusiasts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-f8f2-768c-ac0a-9cf70dcde378.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f8f2-768c-ac0a-9cf70dcde378",
        "storage_key": "property/6767906449165595/019d2708-f8f2-768c-ac0a-9cf70dcde378.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://samnoblemuseum.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15153822275207383505&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sam-noble-oklahoma-museum-of-natural-history",
      "poi_latitude": "35.1944148",
      "poi_longitude": "-97.4489987",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-325-7977",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21ab-7658-84bc-5b6e66b20179.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21ab-7658-84bc-5b6e66b20179",
        "storage_key": "property/6767906449165595/019d2709-21ab-7658-84bc-5b6e66b20179.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJA5eBNjBosocR0UkjJxIxTdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_a0d11fc2-0f17-4bd3-9cdb-008e39376dcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "2800 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "Trampoline park and adventure center featuring go-karts, ropes courses and party rooms.",
      "poi_long_description": "People say this amusement park offers a wide variety of attractions, including go-karts, trampolines, and a ball pit, and is a fun place for birthday parties.\n\nOther reviews mention the go-karts can be slow and the dodgeball area can be unsupervised.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-fa39-7608-af4e-a46eeec24c68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fa39-7608-af4e-a46eeec24c68",
        "storage_key": "property/6767906449165595/019d2708-fa39-7608-af4e-a46eeec24c68.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-moore/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=454199799262834417&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "35.3130452",
      "poi_longitude": "-97.4932574",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-655-5805",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21a4-74db-85b8-362849c7d69d",
        "storage_key": "property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcSyRgFtrsocR8W4dnE-kTQY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_72a677a0-67a0-4e51-abb4-a4a401220ed4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Love’s Field",
      "poi_type": "Entertainment",
      "poi_address": "107 E Constitution St, Norman, OK 73072, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this stadium offers a great place to watch softball. They highlight the intimate atmosphere, excellent seating, and clean facilities. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-fb86-764b-b5bc-520826989961.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fb86-764b-b5bc-520826989961",
        "storage_key": "property/6767906449165595/019d2708-fb86-764b-b5bc-520826989961.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12522865308570512153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-field",
      "poi_latitude": "35.1909663",
      "poi_longitude": "-97.442259",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-20fd-7488-91d2-8dc97920bb73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-20fd-7488-91d2-8dc97920bb73",
        "storage_key": "property/6767906449165595/019d2709-20fd-7488-91d2-8dc97920bb73.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl6yiOXVpsocRGWtoL6Ynyq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_74aeeb05-ae6c-438d-8f10-957f83c159ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Crunch Fitness - Norman",
      "poi_type": "Health and Wellness",
      "poi_address": "2300 W Main St, Norman, OK 73069, USA",
      "poi_short_description": "Friendly gym offering a wide choice of equipment and classes, as well as tanning beds and massage beds, plus kids’ play areas.",
      "poi_long_description": "People say this gym offers great spray tans and a variety of classes. They also highlight the friendly and helpful staff, the clean facility, and the affordable prices.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-fda1-740a-bf1e-8ac0ed8ceee6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fda1-740a-bf1e-8ac0ed8ceee6",
        "storage_key": "property/6767906449165595/019d2708-fda1-740a-bf1e-8ac0ed8ceee6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.crunch.com/locations/norman",
      "poi_directions_map_url": "https://maps.google.com/?cid=6630355039414722733&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---norman",
      "poi_latitude": "35.2168583",
      "poi_longitude": "-97.4760892",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-322-5859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21a4-74db-85b8-362849c7d69d",
        "storage_key": "property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpW-RUHJpsocRrSAJe8fAA1w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e47c1d04-f7d9-49f9-9ac2-6f207add4601",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Norman Regional The Health Club",
      "poi_type": "Health and Wellness",
      "poi_address": "2301 36th Ave NW, Norman, OK 73072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-fd83-72be-92e4-d99325fbf451.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fd83-72be-92e4-d99325fbf451",
        "storage_key": "property/6767906449165595/019d2708-fd83-72be-92e4-d99325fbf451.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanregional.com/the-health-club/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6654177676307732909&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norman-regional-the-health-club",
      "poi_latitude": "35.246075",
      "poi_longitude": "-97.4938832",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-329-5050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21a4-74db-85b8-362849c7d69d",
        "storage_key": "property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY3tEmZNpsocRrRmoXFdjWFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_6c6bac83-7f3b-462f-a8ba-575c4d048121",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "1620 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Specialty retailer selling makeup, fragrances and skin, body and hair care products from over 500 brands.",
      "poi_long_description": "People say this cosmetics store offers a wide selection of makeup and beauty products. They also highlight the rewards program, which provides discounts and other benefits.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2708-fe8a-73da-8eaf-ca56101ed46f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-fe8a-73da-8eaf-ca56101ed46f",
        "storage_key": "property/6767906449165595/019d2708-fe8a-73da-8eaf-ca56101ed46f.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/norman-ok-444",
      "poi_directions_map_url": "https://maps.google.com/?cid=6230795026936720015&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "35.2386275",
      "poi_longitude": "-97.4841919",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-307-9358",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21a4-74db-85b8-362849c7d69d",
        "storage_key": "property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFevmiXhpsocRj2rVmBA7eFY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_9a1553a4-c5e9-42f7-9527-55aed0593514",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "McCasland Field House",
      "poi_type": "Health and Wellness",
      "poi_address": "151 E Brooks St, Norman, OK 73019, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-0066-72df-b345-762c71b25d43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0066-72df-b345-762c71b25d43",
        "storage_key": "property/6767906449165595/019d2709-0066-72df-b345-762c71b25d43.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://soonersports.com/sports/2019/8/12/208803875.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15711730160516803345&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mccasland-field-house",
      "poi_latitude": "35.2079236",
      "poi_longitude": "-97.4423032",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-325-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1c8d-7409-ab9c-e23c1bd6556c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1c8d-7409-ab9c-e23c1bd6556c",
        "storage_key": "property/6767906449165595/019d2709-1c8d-7409-ab9c-e23c1bd6556c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOxFFF9VpsocREStlMFZHC9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_840e39af-6a51-4b9c-9e38-1fa5a0ad180c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Sarkeys Fitness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1401 Asp Ave, Norman, OK 73019, USA",
      "poi_short_description": "University gym and recreation center offering facilities for climbing, basketball, and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-0264-75ad-839f-656b4f934b3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0264-75ad-839f-656b4f934b3d",
        "storage_key": "property/6767906449165595/019d2709-0264-75ad-839f-656b4f934b3d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ou.edu/far",
      "poi_directions_map_url": "https://maps.google.com/?cid=17771863367383165150&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sarkeys-fitness-center",
      "poi_latitude": "35.2014532",
      "poi_longitude": "-97.4428836",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-325-3053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21a4-74db-85b8-362849c7d69d",
        "storage_key": "property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJheeS3ytosocR3qimwZJXovY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_893fc8d9-c821-4e86-9b66-6e53ab5d0ccf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1000 E Alameda St, Norman, OK 73071, USA",
      "poi_short_description": "Chain gym featuring a variety of equipment, tanning, and massage chairs, plus an annual fee.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-02b0-772a-85c9-21bc6b3ace59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-02b0-772a-85c9-21bc6b3ace59",
        "storage_key": "property/6767906449165595/019d2709-02b0-772a-85c9-21bc6b3ace59.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/norman-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=16953030002874658196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.217743",
      "poi_longitude": "-97.4256219",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-633-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21a4-74db-85b8-362849c7d69d",
        "storage_key": "property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJozN9VQ1DsocRlC3ic_dCRes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_673e6dca-03bf-46da-8729-ec6939a27c0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Filed Nails Spa Beauty, Norman, OK",
      "poi_type": "Health and Wellness",
      "poi_address": "3408 36th Ave NW STE 116, Norman, OK 73072, USA",
      "poi_short_description": "Casual nail salon offering manis-pedis, plus acrylics & customized nail art.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-0440-7316-b823-e34cf193852f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0440-7316-b823-e34cf193852f",
        "storage_key": "property/6767906449165595/019d2709-0440-7316-b823-e34cf193852f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.filednailspa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7696990407116716923&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "filed-nails-spa-beauty-norman-ok",
      "poi_latitude": "35.2587242",
      "poi_longitude": "-97.4947891",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-801-4015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21a4-74db-85b8-362849c7d69d",
        "storage_key": "property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtXLsUUdrsocRe_vHr_4z0Wo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_89816a3a-92f7-4e7d-89c4-54e177666c6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Bart Conner Gymnastics Academy",
      "poi_type": "Health and Wellness",
      "poi_address": "3206 Bart Conner Dr, Norman, OK 73072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-04fb-7128-9ff0-aa391c1bc228.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-04fb-7128-9ff0-aa391c1bc228",
        "storage_key": "property/6767906449165595/019d2709-04fb-7128-9ff0-aa391c1bc228.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bartconnergymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15326641727485596774&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bart-conner-gymnastics-academy",
      "poi_latitude": "35.250054",
      "poi_longitude": "-97.4879725",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 405-447-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1c8d-7409-ab9c-e23c1bd6556c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1c8d-7409-ab9c-e23c1bd6556c",
        "storage_key": "property/6767906449165595/019d2709-1c8d-7409-ab9c-e23c1bd6556c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxzVqktZrsocRZlR1dnIrs9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2e500c51-5fcb-4b82-8c1c-116a5bc74ece",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Victory Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "5721 Huettner Dr, Norman, OK 73069, USA",
      "poi_short_description": "Gymnastics center offering recreational classes, AAU and USAG competitive teams, and summer camps.",
      "poi_long_description": "People say this gymnastics center offers recreational classes, private lessons, and summer camps. They highlight the fun and engaging activities, and the positive impact on children's confidence and skills. They also like the kind, patient, and knowledgeable coaches and staff. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-0793-7535-b220-153f1a12f50c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0793-7535-b220-153f1a12f50c",
        "storage_key": "property/6767906449165595/019d2709-0793-7535-b220-153f1a12f50c.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "http://www.victorygymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16832765422714147590&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "victory-gymnastics",
      "poi_latitude": "35.287754",
      "poi_longitude": "-97.483823",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-688-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1c8d-7409-ab9c-e23c1bd6556c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-1c8d-7409-ab9c-e23c1bd6556c",
        "storage_key": "property/6767906449165595/019d2709-1c8d-7409-ab9c-e23c1bd6556c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxeHRVqprsocRBtNa2Pf-mek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e7eacca3-fefd-4705-97ab-2b3d228a9c22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Norman Regional Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "3300 Healthplex Pkwy, Norman, OK 73072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-087d-7638-bedb-60aef589925b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-087d-7638-bedb-60aef589925b",
        "storage_key": "property/6767906449165595/019d2709-087d-7638-bedb-60aef589925b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.normanregional.com/locations/norman-regional-hospital/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5166678913039723209&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norman-regional-hospital",
      "poi_latitude": "35.2599491",
      "poi_longitude": "-97.4885857",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-515-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-250a-7199-9a74-60ad4414cd19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-250a-7199-9a74-60ad4414cd19",
        "storage_key": "property/6767906449165595/019d2709-250a-7199-9a74-60ad4414cd19.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJp8UVz89rsocRyeo74Bi7s0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_dd4b3565-1301-4e3a-bdf6-f300d2375355",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Norman Regional Moore",
      "poi_type": "Health and Wellness",
      "poi_address": "700 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-0948-7179-ac73-1c28f30d2c65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0948-7179-ac73-1c28f30d2c65",
        "storage_key": "property/6767906449165595/019d2709-0948-7179-ac73-1c28f30d2c65.webp",
        "width": 1280,
        "height": 785
      },
      "poi_business_url": "https://www.normanregional.com/locations/norman-regional-moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6671442604466481346&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norman-regional-moore",
      "poi_latitude": "35.3325506",
      "poi_longitude": "-97.4932073",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-793-9355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-250a-7199-9a74-60ad4414cd19.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-250a-7199-9a74-60ad4414cd19",
        "storage_key": "property/6767906449165595/019d2709-250a-7199-9a74-60ad4414cd19.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJdxkYvjJrsocRwqihsrO5lVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_94e870e7-8f67-4635-b6b7-a4f3eab8cf2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Reaves Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2501 Jenkins Ave, Norman, OK 73072, USA",
      "poi_short_description": "Green space featuring a playground and baseball fields, plus an annual medieval fair.",
      "poi_long_description": "People say this park offers a fun wooden playground and separate play areas for different age groups. They highlight the park is clean, well-maintained, and spacious, and the atmosphere is safe and quiet. They also like that it's a great place for family traditions. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-0b84-711b-989f-c44127e729c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0b84-711b-989f-c44127e729c4",
        "storage_key": "property/6767906449165595/019d2709-0b84-711b-989f-c44127e729c4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/reaves-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16930546161794306208&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "reaves-park",
      "poi_latitude": "35.1938945",
      "poi_longitude": "-97.4407046",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-250d-7729-b6ad-b5036d23a391.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-250d-7729-b6ad-b5036d23a391",
        "storage_key": "property/6767906449165595/019d2709-250d-7729-b6ad-b5036d23a391.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJNR5d9idosocRoFAaQwhi9eo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7fa3d68d-f735-425f-8254-ca5d75a8680d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Little River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "709 SW 10th St, Moore, OK 73160, USA",
      "poi_short_description": "Family-friendly park with a splash park, a playground and a pirate ship.",
      "poi_long_description": "People say this park offers a fun splash pad with water slides, a playground, and walking trails. They highlight the free admission and the mini water park experience. They also like the plentiful seating and the fenced splash pad.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-0d5e-725d-9c0b-adcc88cd5791.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0d5e-725d-9c0b-adcc88cd5791",
        "storage_key": "property/6767906449165595/019d2709-0d5e-725d-9c0b-adcc88cd5791.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofmoore.com/departments/parks-recreation/locations-amenities/little-river-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13309531068765424630&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "little-river-park",
      "poi_latitude": "35.3275656",
      "poi_longitude": "-97.50192",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-793-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-250d-7729-b6ad-b5036d23a391.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-250d-7729-b6ad-b5036d23a391",
        "storage_key": "property/6767906449165595/019d2709-250d-7729-b6ad-b5036d23a391.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1cPHdTZrsocR9svJeP3ztLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8995cdd2-403f-41f7-9192-cf26169dd395",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Sutton Wilderness Trail Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1920 12th Ave NE, Norman, OK 73071, USA",
      "poi_short_description": "Dog-friendly outdoor lake loop featuring flat trails and wooded areas for walking, jogging and biking.",
      "poi_long_description": "People say this park offers trails for walking, jogging, and biking, as well as fishing and nature exploration. They highlight the peaceful and relaxing atmosphere, and the beautiful scenery with a pond and plenty of shade. They also like that it's pet-friendly and suitable for families.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-0dcd-7402-ada6-39b6c30acbbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0dcd-7402-ada6-39b6c30acbbd",
        "storage_key": "property/6767906449165595/019d2709-0dcd-7402-ada6-39b6c30acbbd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/george-m-sutton-wilderness-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1152383032856291791&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutton-wilderness-trail-park",
      "poi_latitude": "35.24229710000001",
      "poi_longitude": "-97.4238198",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-250d-7729-b6ad-b5036d23a391.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-250d-7729-b6ad-b5036d23a391",
        "storage_key": "property/6767906449165595/019d2709-250d-7729-b6ad-b5036d23a391.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQYvmTBpCsocRzymWRkMW_g8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e4f5dfd1-d3c9-47ec-ab48-2adfb4c34b59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Andrews Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "201 W Daws St, Norman, OK 73069, USA",
      "poi_short_description": "Sprawling destination showcasing multiple playgrounds, a skate park and an amphitheater.",
      "poi_long_description": "People say this park offers an amphitheater, skate park, basketball court, picnic areas, and a splash pad. They highlight the open space, walking trails, and interesting art installations. They also like the gazebos and play parks. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-0e42-751c-ae17-079493ebba7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-0e42-751c-ae17-079493ebba7d",
        "storage_key": "property/6767906449165595/019d2709-0e42-751c-ae17-079493ebba7d.webp",
        "width": 650,
        "height": 424
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/andrews-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15551216504880236359&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "andrews-park",
      "poi_latitude": "35.2240718",
      "poi_longitude": "-97.4478907",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-250d-7729-b6ad-b5036d23a391.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-250d-7729-b6ad-b5036d23a391",
        "storage_key": "property/6767906449165595/019d2709-250d-7729-b6ad-b5036d23a391.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9ymuIN1psocRRweUbgQF0dc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_54667313-f591-4c44-a1b0-c76d2c8d2758",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Ruby Grant Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3110 W Franklin Rd, Norman, OK 73072, USA",
      "poi_short_description": "Park featuring play areas, barbecue grills and disc golf, along with hiking and walking trails.",
      "poi_long_description": "People say this park offers a fun walk and a disc golf course. They highlight the well-maintained area and the full sun exposure. They also like the proximity to a dog park. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1055-7061-b939-7c3cd848ada1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1055-7061-b939-7c3cd848ada1",
        "storage_key": "property/6767906449165595/019d2709-1055-7061-b939-7c3cd848ada1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/ruby-grant-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=69868048196119437&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ruby-grant-park",
      "poi_latitude": "35.2756272",
      "poi_longitude": "-97.489092",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-250d-7729-b6ad-b5036d23a391.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-250d-7729-b6ad-b5036d23a391",
        "storage_key": "property/6767906449165595/019d2709-250d-7729-b6ad-b5036d23a391.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYZIsdtrsocRjSvhoZ44-AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d298c306-f6db-406d-860a-65402c6d9d3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Max Westheimer Airport KOUN",
      "poi_type": "Transportation & Transit",
      "poi_address": "1700 Lexington Ave #109, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1223-7029-a832-019d0391180b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1223-7029-a832-019d0391180b",
        "storage_key": "property/6767906449165595/019d2709-1223-7029-a832-019d0391180b.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "http://airport.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12939952151657294093&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "max-westheimer-airport-koun",
      "poi_latitude": "35.2409761",
      "poi_longitude": "-97.4680511",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-325-7233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-25ae-75d8-b457-4f85ea4c96dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-25ae-75d8-b457-4f85ea4c96dc",
        "storage_key": "property/6767906449165595/019d2709-25ae-75d8-b457-4f85ea4c96dc.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9TluYdpsocRDakVUuzxk7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_b0cf10c0-9e84-4328-b649-ad33289c5831",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Norman",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 S Jones Ave, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1370-73ca-b66f-94c3ab0ead36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1370-73ca-b66f-94c3ab0ead36",
        "storage_key": "property/6767906449165595/019d2709-1370-73ca-b66f-94c3ab0ead36.webp",
        "width": 1279,
        "height": 1280
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=NOR",
      "poi_directions_map_url": "https://maps.google.com/?cid=15732860998083481142&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norman",
      "poi_latitude": "35.2198854",
      "poi_longitude": "-97.4428739",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-25e9-774e-bc11-a25076c39212.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-25e9-774e-bc11-a25076c39212",
        "storage_key": "property/6767906449165595/019d2709-25e9-774e-bc11-a25076c39212.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJdSTOcdlpsocRNg5ds7hZVto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_ffcc8e3b-fee9-4a46-a427-c523e043a8fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Simple Modern Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "750 SW 24th St Suite 300, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-135d-77cb-80ab-412c6096372a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-135d-77cb-80ab-412c6096372a",
        "storage_key": "property/6767906449165595/019d2709-135d-77cb-80ab-412c6096372a.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "http://simplemodern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5364504164759517206&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "simple-modern-headquarters",
      "poi_latitude": "35.3164404",
      "poi_longitude": "-97.5021957",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21a4-74db-85b8-362849c7d69d",
        "storage_key": "property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfe83ix9rsocRFjiYkB2Mcko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bc05bc29-ec81-4eea-8309-98e3184a136c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Integrated Power Services (IPS) - Norman",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6707 N Interstate Dr, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-15d9-7269-83e2-73143a8c0352.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-15d9-7269-83e2-73143a8c0352",
        "storage_key": "property/6767906449165595/019d2709-15d9-7269-83e2-73143a8c0352.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://ips.us/location/evans-norman/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2485684183795281028&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "integrated-power-services-ips---norman",
      "poi_latitude": "35.2991008",
      "poi_longitude": "-97.4888055",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-631-1344",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21a4-74db-85b8-362849c7d69d",
        "storage_key": "property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqenS6wRrsocRhKzsbpjsfiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a6d953bc-9556-4023-b0ef-0cb6a77df57d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "WFEC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3000 S Telephone Rd, Moore, OK 73160, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-1830-76b7-b152-713a019f894a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-1830-76b7-b152-713a019f894a",
        "storage_key": "property/6767906449165595/019d2709-1830-76b7-b152-713a019f894a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.wfec.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11816483374180755416&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "wfec",
      "poi_latitude": "35.31055600000001",
      "poi_longitude": "-97.4938519",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-759-2620",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21a4-74db-85b8-362849c7d69d",
        "storage_key": "property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-U_1KhZrsocR2GdavAWV_KM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4ad8bd18-ff68-4ff2-bf58-943cf79210ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Trans-Tel Central, LLC Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2851 N Flood Ave, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://trans-tel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966786705039048130&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trans-tel-central-llc-corporate-office",
      "poi_latitude": "35.2534979",
      "poi_longitude": "-97.4657052",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-447-5025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-21a4-74db-85b8-362849c7d69d",
        "storage_key": "property/6767906449165595/019d2709-21a4-74db-85b8-362849c7d69d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWsrK9drsocRwj2MCgBtcHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e7b96f3a-97a4-4250-9136-02df3f1dcd67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "N Santa Fe Ave, Norman, OK 73069, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-18b2-72f5-9ac1-a6a2305dda48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-18b2-72f5-9ac1-a6a2305dda48",
        "storage_key": "property/6767906449165595/019d2709-18b2-72f5-9ac1-a6a2305dda48.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106083913883470512&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-hall",
      "poi_latitude": "35.2216835",
      "poi_longitude": "-97.4467697",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d2709-2102-70b8-ba2f-46a4b28df070.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2709-2102-70b8-ba2f-46a4b28df070",
        "storage_key": "property/6767906449165595/019d2709-2102-70b8-ba2f-46a4b28df070.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ84qUfdtpsocRsEoMEbAEZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_495400d6-ecc0-4692-9771-12e913645056",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Truman Elementary School",
      "poi_type": "Education",
      "poi_address": "600 Parkside Rd, Norman, OK 73072, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.normanpublicschools.org/o/tes",
      "poi_directions_map_url": "https://maps.google.com/?cid=10205172901439551536&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "truman-elementary-school",
      "poi_latitude": "35.227158",
      "poi_longitude": "-97.502092",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-366-5980",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-2786-7018-aa0c-243260f73bb8",
        "storage_key": "property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHyYXyUFpsocRMDi_Pa8OoI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_cb5c2b50-4ae1-4794-b16f-417ea6b0d334",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Cleveland Elementary School",
      "poi_type": "Education",
      "poi_address": "500 N Sherry Ave, Norman, OK 73069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.normanpublicschools.org/o/ces",
      "poi_directions_map_url": "https://maps.google.com/?cid=17605047883712768948&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cleveland-elementary-school",
      "poi_latitude": "35.2249808",
      "poi_longitude": "-97.4689872",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-366-5875",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-2786-7018-aa0c-243260f73bb8",
        "storage_key": "property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ320wYL1psocRtCtxUsaxUfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a04600b1-03a2-4311-bf87-1552e62de35b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Alcott Middle School",
      "poi_type": "Education",
      "poi_address": "1919 W Boyd St, Norman, OK 73069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.norman.k12.ok.us/o/ams",
      "poi_directions_map_url": "https://maps.google.com/?cid=517195452663907001&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "alcott-middle-school",
      "poi_latitude": "35.2116707",
      "poi_longitude": "-97.4703548",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-366-5845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-2786-7018-aa0c-243260f73bb8",
        "storage_key": "property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJizgKJbBpsocRucJ6I4ZyLQc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_076f907e-c23d-4820-81a9-b5b41e4cd593",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Whittier Middle School",
      "poi_type": "Education",
      "poi_address": "2000 W Brooks St, Norman, OK 73069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.normanpublicschools.org/o/wms",
      "poi_directions_map_url": "https://maps.google.com/?cid=734852442206075257&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whittier-middle-school",
      "poi_latitude": "35.20726940000001",
      "poi_longitude": "-97.471395",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-366-5956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-2786-7018-aa0c-243260f73bb8",
        "storage_key": "property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpS0Kh7JpsocReXkFHGe4Mgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_8cfed601-b12d-42fc-8f4f-c63603ea8371",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Norman North High School",
      "poi_type": "Education",
      "poi_address": "1809 Stubbeman Ave, Norman, OK 73069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-1496-7029-806b-5c38706f6a6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1496-7029-806b-5c38706f6a6d",
        "storage_key": "property/6767906449165595/019d7912-1496-7029-806b-5c38706f6a6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.normanpublicschools.org/o/nnhs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6040937795953896976&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "norman-north-high-school",
      "poi_latitude": "35.2405884",
      "poi_longitude": "-97.4493185",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 405-366-5954",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-2786-7018-aa0c-243260f73bb8",
        "storage_key": "property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ46BhfvBpsocREC4QTuu41VM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_56e2b641-b563-40ef-bd6c-c8f6e541a5b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Community Christian School",
      "poi_type": "Education",
      "poi_address": "3002 Broce Dr, Norman, OK 73072, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-13d1-743e-9355-a5e4558279f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-13d1-743e-9355-a5e4558279f6",
        "storage_key": "property/6767906449165595/019d7912-13d1-743e-9355-a5e4558279f6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.communitychristianschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14100489665613167140&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "community-christian-school",
      "poi_latitude": "35.2537047",
      "poi_longitude": "-97.4866949",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-329-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-2786-7018-aa0c-243260f73bb8",
        "storage_key": "property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-0nQ49NrsocRJHrwraQAr8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_222666a9-1658-4de4-9187-7459b0cf6751",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "University of Oklahoma North Campus",
      "poi_type": "Education",
      "poi_address": "1928 Goddard Ave, Norman, OK 73069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-15a3-778d-9611-f7669895cfaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-15a3-778d-9611-f7669895cfaa",
        "storage_key": "property/6767906449165595/019d7912-15a3-778d-9611-f7669895cfaa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://aviation.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2356597387237958594&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "university-of-oklahoma-north-campus",
      "poi_latitude": "35.2422826",
      "poi_longitude": "-97.4666131",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-2786-7018-aa0c-243260f73bb8",
        "storage_key": "property/6767906449165595/019cfb3d-2786-7018-aa0c-243260f73bb8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ50quyo5psocRwqPugNZQtCA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5f688581-8fa3-444f-b9e8-d7aefdf07d37",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Volcano Sushi Bar & Hibachi",
      "poi_type": "Restaurants",
      "poi_address": "3700 W Robinson St Suite 164, Norman, OK 73072, USA",
      "poi_short_description": "Casual eatery with hibachi meals and familiar sushi options such as shrimp tempura rolls.",
      "poi_long_description": "Diners say this sushi restaurant serves up delicious sushi and classic hibachi dishes. They also highlight the friendly staff and excellent service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-1697-76d8-8d85-5ba9df145e88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1697-76d8-8d85-5ba9df145e88",
        "storage_key": "property/6767906449165595/019d7912-1697-76d8-8d85-5ba9df145e88.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://volcanook.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16802460160150467224&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "volcano-sushi-bar-hibachi",
      "poi_latitude": "35.2318305",
      "poi_longitude": "-97.49587",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-928-5388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-278e-72a8-9ef3-8091c2733a60",
        "storage_key": "property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqS6FyqZpsocRmPJrDn5ULuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_05341a74-29d3-44fb-9287-f9f2fdaabbfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "DoubleDave's Pizzaworks",
      "poi_type": "Restaurants",
      "poi_address": "3201 Market Pl, Norman, OK 73069, USA",
      "poi_short_description": "Chain counter-serve pizzeria known for its Peproni Rolls & make-your-own pizzas.",
      "poi_long_description": "Chain counter-serve pizzeria known for its Peproni Rolls & make-your-own pizzas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-1c47-708e-a5b4-ec300f1e7e89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1c47-708e-a5b4-ec300f1e7e89",
        "storage_key": "property/6767906449165595/019d7912-1c47-708e-a5b4-ec300f1e7e89.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.doubledaves.com/locations/ok/norman?utm_medium=yext&utm_source=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12808932401094821317&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "doubledave-s-pizzaworks",
      "poi_latitude": "35.2943079",
      "poi_longitude": "-97.4901785",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-310-3283",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-278e-72a8-9ef3-8091c2733a60",
        "storage_key": "property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJsxQyZAZrsocRxYU_dyd4wrE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_5f82e242-1c3b-4f5b-83e2-2beea6f63240",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "CAVA",
      "poi_type": "Restaurants",
      "poi_address": "1651 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Mediterranean restaurant for thoughtful food with customizable greens & grains bowls, pitas & salad.",
      "poi_long_description": "People say this Mediterranean restaurant offers fresh, flavorful food with large portions. They also highlight the friendly and helpful staff, and the clean and efficient atmosphere.\n\nOther reviews mention the food can be pricey.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-1f1e-707e-8be0-ac61a8d57c68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1f1e-707e-8be0-ac61a8d57c68",
        "storage_key": "property/6767906449165595/019d7912-1f1e-707e-8be0-ac61a8d57c68.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://cava.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13688041471257765714&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cava",
      "poi_latitude": "35.2391769",
      "poi_longitude": "-97.4815039",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-701-6908",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-278e-72a8-9ef3-8091c2733a60",
        "storage_key": "property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq0aFPsppsocRUmciHTKx9b0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_443fa916-7e83-4ed7-a2cc-4339e39622d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "2070 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "People say this restaurant serves delicious burgers, chicken tenders, and quesadillas. They also highlight the excellent margaritas, the friendly and attentive staff, and the quick service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-1eda-773d-8ee4-2736d6b87b37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1eda-773d-8ee4-2736d6b87b37",
        "storage_key": "property/6767906449165595/019d7912-1eda-773d-8ee4-2736d6b87b37.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chilis.com/locations?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=3423207852788408898&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chili-s-grill-bar",
      "poi_latitude": "35.24318700000001",
      "poi_longitude": "-97.481321",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-364-0530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-278e-72a8-9ef3-8091c2733a60",
        "storage_key": "property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQyXtiHdrsocRQuLHuWetgS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_07eca55a-c3ee-4635-9fe5-b7c43a5ca7bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Hideaway Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1353 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Local chain featuring build-your-own pies, a variety of Italian fare & a kids' menu.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizza with a wide variety of toppings, as well as tasty meatballs, wings, and salads. They highlight the great value, especially during happy hour, and the fun, lively atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-207e-7747-a74c-9f7340923719.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-207e-7747-a74c-9f7340923719",
        "storage_key": "property/6767906449165595/019d7912-207e-7747-a74c-9f7340923719.webp",
        "width": 1280,
        "height": 1024
      },
      "poi_business_url": "https://www.hideawaypizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8715095220064223911&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hideaway-pizza",
      "poi_latitude": "35.2357239",
      "poi_longitude": "-97.4799339",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-231-4778",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-278e-72a8-9ef3-8091c2733a60",
        "storage_key": "property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxxdQE95psocRpwKil-088ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_8dc6ddcc-af80-4380-992c-67f40ea91439",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "la Madeleine",
      "poi_type": "Restaurants",
      "poi_address": "1954 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Quaint French cafe chain serving rustic country fare, espresso & fresh-baked baguettes.",
      "poi_long_description": "People say this restaurant serves delicious French comfort food, including tomato basil soup, chicken salad sandwiches, and a variety of pastries. They also highlight the friendly and helpful service, and the pleasant, cozy atmosphere with indoor and outdoor seating.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-2456-72bf-ab4f-90ec1ee31572.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2456-72bf-ab4f-90ec1ee31572",
        "storage_key": "property/6767906449165595/019d7912-2456-72bf-ab4f-90ec1ee31572.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lamadeleine.com/locations/university-town-center-norman",
      "poi_directions_map_url": "https://maps.google.com/?cid=2463316848549723980&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "la-madeleine",
      "poi_latitude": "35.242112",
      "poi_longitude": "-97.483043",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-416-1942",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-278e-72a8-9ef3-8091c2733a60",
        "storage_key": "property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ18t7VH9psocRTH8KX591LyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_9b534253-ddce-4157-bd34-c876a0afd103",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Mo' Bettahs Hawaiian Style Food",
      "poi_type": "Restaurants",
      "poi_address": "2081 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Casual joint dishing up Hawaiian fast food, including teriyaki chicken, katsu, and pulehu plates.",
      "poi_long_description": "Diners say this Hawaiian restaurant serves up delicious teriyaki steak, kalua pig, and spam musubi, with many raving about the macaroni salad. They also highlight the friendly staff, quick service, and generous portions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-2830-77b1-962d-ba1c7e9ae94b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2830-77b1-962d-ba1c7e9ae94b",
        "storage_key": "property/6767906449165595/019d7912-2830-77b1-962d-ba1c7e9ae94b.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://locations.mobettahs.com/ok/norman/norman/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8656151009502374641&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mo-bettahs-hawaiian-style-food",
      "poi_latitude": "35.2426054",
      "poi_longitude": "-97.4801289",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-265-5194",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-278e-72a8-9ef3-8091c2733a60",
        "storage_key": "property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQloNM9psocR8SqHG3vTIHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hawaiian_restaurant"
    },
    {
      "id": "custom_9d881219-a3b6-4cc7-b8bd-e45f282bdabf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Pub W",
      "poi_type": "Restaurants",
      "poi_address": "3720 W Robinson St, Norman, OK 73072, USA",
      "poi_short_description": "Pub grub including a popular meatloaf, plus beer, wine, and cocktails, served in a casual space.",
      "poi_long_description": "People say this restaurant serves amazing burgers, fried chicken, and appetizers. They highlight the food is delicious and of great quality. They also like the comfortable atmosphere and good service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-2ac6-775d-88b9-b4972a85dfa1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2ac6-775d-88b9-b4972a85dfa1",
        "storage_key": "property/6767906449165595/019d7912-2ac6-775d-88b9-b4972a85dfa1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://pubdub.com/locations/pub-w-norman/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7388445299987295822&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pub-w",
      "poi_latitude": "35.2308259",
      "poi_longitude": "-97.4951277",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-701-5844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-278e-72a8-9ef3-8091c2733a60",
        "storage_key": "property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ61LTi25psocRTq4lzNoHiWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_5648705f-7682-474e-a5d5-963a76104439",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Redrock Canyon Grill",
      "poi_type": "Restaurants",
      "poi_address": "1820 Legacy Park Drive, Norman, OK 73069, USA",
      "poi_short_description": "Easygoing bistro & bar turning out wood-fired rotisserie chicken & Southwest-inspired dishes.",
      "poi_long_description": "People say this restaurant serves delicious ribs, steak, and rotisserie chicken. They highlight the great atmosphere, friendly staff, and well-timed food arrival. They also like the well-stocked bar and delicious drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-2ce9-712a-a3d3-89d18a870051.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2ce9-712a-a3d3-89d18a870051",
        "storage_key": "property/6767906449165595/019d7912-2ce9-712a-a3d3-89d18a870051.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.redrockcanyongrill.com/locations/norman/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6133070644336653857&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "redrock-canyon-grill",
      "poi_latitude": "35.2402766",
      "poi_longitude": "-97.4839406",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-701-5501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-278e-72a8-9ef3-8091c2733a60",
        "storage_key": "property/6767906449165595/019cfb3d-278e-72a8-9ef3-8091c2733a60.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA0xD3XhpsocRIfYPskELHVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_dd5a5ad4-c10e-4584-972a-2ed4cab41202",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Beanstalk Coffee and Sno",
      "poi_type": "Restaurants",
      "poi_address": "3408 36th Ave NW Suite 124 Suite 124, Norman, OK 73072, USA",
      "poi_short_description": "Cute, relaxed, clean coffee shop dishing up snow cones, as well as pastries and baked goods, plus friendly service.",
      "poi_long_description": "People say this coffee shop offers delicious coffee, snow cones, and pastries, including a popular \"Ben's Blend\" espresso and a honey-sweetened matcha latte. They highlight the unique, Jack and the Beanstalk-themed atmosphere, and the free coffee grounds for gardening. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-2e27-7791-8869-a5e01a48c833.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-2e27-7791-8869-a5e01a48c833",
        "storage_key": "property/6767906449165595/019d7912-2e27-7791-8869-a5e01a48c833.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.beanstalkcoffeeandsno.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5707346999777982871&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "beanstalk-coffee-and-sno",
      "poi_latitude": "35.258979",
      "poi_longitude": "-97.4949639",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-887-4484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-8e96-71e7-bca7-f77473d21b4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-8e96-71e7-bca7-f77473d21b4f",
        "storage_key": "property/6767906449165595/019d7912-8e96-71e7-bca7-f77473d21b4f.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJHZTSbilrsocRl3mog9uRNE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_d3e3146c-13aa-4ccb-87c8-a9fb196788e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "2010 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "People say this sporting goods store offers a wide selection of sports and outdoor goods, including clothing, shoes, and accessories. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-39e0-7108-b443-69204adc9f7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-39e0-7108-b443-69204adc9f7c",
        "storage_key": "property/6767906449165595/019d7912-39e0-7108-b443-69204adc9f7c.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/oklahoma/norman/store-0204",
      "poi_directions_map_url": "https://maps.google.com/?cid=7523992233536915356&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "academy-sports-outdoors",
      "poi_latitude": "35.2433474",
      "poi_longitude": "-97.4837816",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-307-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-276f-779c-952a-dbd0e3a058a8",
        "storage_key": "property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJL5NGMHJpsocRnAfElBKXamg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_e9029b50-39fe-49dd-b83a-e9a4f667e0bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Petco",
      "poi_type": "Shopping & Retail",
      "poi_address": "1670 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_long_description": "People say this pet store offers a wide selection of pet supplies, including food, treats, toys, clothing, and accessories for various animals. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-3a52-74c4-8916-f99ceedb9df4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3a52-74c4-8916-f99ceedb9df4",
        "storage_key": "property/6767906449165595/019d7912-3a52-74c4-8916-f99ceedb9df4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.petco.com/ok/norman/pet-supplies-norman-ok-1484.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6033723219374733061&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petco",
      "poi_latitude": "35.2391485",
      "poi_longitude": "-97.4842363",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-579-0487",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-276f-779c-952a-dbd0e3a058a8",
        "storage_key": "property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJFevmiXhpsocRBXfby0wXvFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_store"
    },
    {
      "id": "custom_6f802b74-9402-462d-983c-2a6f8fe3b063",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "T.J. Maxx",
      "poi_type": "Shopping & Retail",
      "poi_address": "1580 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "People say this department store offers a wide selection of products and a great shopping experience. They also highlight the excellent prices, friendly and helpful staff, and well-organized layout.\n\nOther reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-3cfa-745e-8b61-8f6138e30458.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-3cfa-745e-8b61-8f6138e30458",
        "storage_key": "property/6767906449165595/019d7912-3cfa-745e-8b61-8f6138e30458.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9736793832595413285&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "t-j-maxx",
      "poi_latitude": "35.2378644",
      "poi_longitude": "-97.4838136",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-579-1648",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-276f-779c-952a-dbd0e3a058a8",
        "storage_key": "property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJiZ74iXhpsocRJVkQK2cKIIc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f7d5988a-217d-4444-9b91-a2e1b2e34926",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Michaels",
      "poi_type": "Shopping & Retail",
      "poi_address": "University Town Center at University North Park, 2040 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_long_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-4305-772e-a9a6-62644c0c0e59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4305-772e-a9a6-62644c0c0e59",
        "storage_key": "property/6767906449165595/019d7912-4305-772e-a9a6-62644c0c0e59.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.michaels.com/OK/Norman/5048/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=11137369364491516680&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "michaels",
      "poi_latitude": "35.2441121",
      "poi_longitude": "-97.4826258",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-329-1665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-276f-779c-952a-dbd0e3a058a8",
        "storage_key": "property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfTvw5oFpsocRCLvVvm3ij5o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_bf5184ba-4846-4815-90a6-a1d8cfa0d5e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "University Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "1690 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Mall with a variety of stores, including Target, as well as dining options.",
      "poi_long_description": "People say this shopping center offers a variety of shops and food options, including pizza, burgers, and chicken. They highlight the convenient location, the well-maintained property, and the pleasant walking path. They also like the prompt service and the fun, relaxing atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-48b4-717a-89cb-fc6a8ca7e005.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-48b4-717a-89cb-fc6a8ca7e005",
        "storage_key": "property/6767906449165595/019d7912-48b4-717a-89cb-fc6a8ca7e005.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8427203895907282005&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "university-town-center",
      "poi_latitude": "35.2383269",
      "poi_longitude": "-97.4826936",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-276f-779c-952a-dbd0e3a058a8",
        "storage_key": "property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPS9HZ3hpsocRVWxXSUtx83Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ed138979-6c6d-40a1-8286-7928a6d6e89c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Brookhaven Village",
      "poi_type": "Shopping & Retail",
      "poi_address": "3700 W Robinson St, Norman, OK 73072, USA",
      "poi_short_description": "Strip mall with dining, a gym, and a bar, as well as shopping.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-480e-71a5-82a5-13cc8396b798.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-480e-71a5-82a5-13cc8396b798",
        "storage_key": "property/6767906449165595/019d7912-480e-71a5-82a5-13cc8396b798.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://brookhaven-village.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6434473757137990277&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "brookhaven-village",
      "poi_latitude": "35.2317785",
      "poi_longitude": "-97.4955495",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-321-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-276f-779c-952a-dbd0e3a058a8",
        "storage_key": "property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJa39U7m5psocRhXLIcsrXS1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e975a4b1-bc6c-4f3a-8572-766ff6b8dbbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Campus Corner",
      "poi_type": "Shopping & Retail",
      "poi_address": "Campus Corner, Norman, OK 73069, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-4f63-71db-9941-dd7e0e13b6ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4f63-71db-9941-dd7e0e13b6ec",
        "storage_key": "property/6767906449165595/019d7912-4f63-71db-9941-dd7e0e13b6ec.webp",
        "width": 1031,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6152393087812073139&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "campus-corner",
      "poi_latitude": "35.212783",
      "poi_longitude": "-97.4438821",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-277d-75a7-b1f7-e33c8c8261ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-277d-75a7-b1f7-e33c8c8261ca",
        "storage_key": "property/6767906449165595/019cfb3d-277d-75a7-b1f7-e33c8c8261ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6VlFydZpsocRs3abpeqwYVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c9eedf55-21a2-4cec-b393-928101f0e97f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Bath & Body Works",
      "poi_type": "Shopping & Retail",
      "poi_address": "1550 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Chain with housebrand lotions & soaps in a range of scents, plus candles & home fragrances.",
      "poi_long_description": "People say this beauty supply store offers a great selection of candles, body wash, and lotion, including holiday seasonal products. They highlight the fresh, clean, and inviting atmosphere. They also like the knowledgeable and approachable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-4cf6-72de-baac-4e8ae00d62dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-4cf6-72de-baac-4e8ae00d62dd",
        "storage_key": "property/6767906449165595/019d7912-4cf6-72de-baac-4e8ae00d62dd.webp",
        "width": 1280,
        "height": 858
      },
      "poi_business_url": "https://www.bathandbodyworks.com/?cm_mmc=local_BBW02364",
      "poi_directions_map_url": "https://maps.google.com/?cid=821420943892409293&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bath-body-works",
      "poi_latitude": "35.237682",
      "poi_longitude": "-97.4838947",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-253-2160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-276f-779c-952a-dbd0e3a058a8",
        "storage_key": "property/6767906449165595/019cfb3d-276f-779c-952a-dbd0e3a058a8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF2oNTHhpsocRzevFE_9FZgs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_ad2d53ff-dda1-4319-b1ce-2ba1e8f39cea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Vintage Stock",
      "poi_type": "Shopping & Retail",
      "poi_address": "1700 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Home-entertainment chain that buys & sells movies, music & games, books, comics, toys & memorabilia.",
      "poi_long_description": "People say this DVD store offers a wide variety of DVDs, CDs, games, and game systems at good prices. They also highlight the cool and interesting items that can be found in the store.\n\nSome reviews mention the staff can be impolite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-5eed-76ff-b995-cdd2f1f21aac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-5eed-76ff-b995-cdd2f1f21aac",
        "storage_key": "property/6767906449165595/019d7912-5eed-76ff-b995-cdd2f1f21aac.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "https://vintagestock.com/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=7639249433050239736&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vintage-stock",
      "poi_latitude": "35.2395909",
      "poi_longitude": "-97.4836782",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-307-0004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-277d-75a7-b1f7-e33c8c8261ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-277d-75a7-b1f7-e33c8c8261ca",
        "storage_key": "property/6767906449165595/019cfb3d-277d-75a7-b1f7-e33c8c8261ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFevmiXhpsocR-FKQh-IQBGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_c7a30406-6b5d-4fae-b49c-03e57939990a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Legacy Park",
      "poi_type": "Entertainment",
      "poi_address": "1898 Legacy Park Drive, Norman, OK 73069, USA",
      "poi_short_description": "Picnic spot set around a water feature with multiple fountains, paths & a modern amphitheater.",
      "poi_long_description": "People say this park offers grassy areas, a calming water body, and a stage for cultural activities. They highlight the park is a good place for big gatherings and events, such as the Water Lantern Festival. They also like the clean and beautiful environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-63c3-7533-9550-759b767170ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-63c3-7533-9550-759b767170ec",
        "storage_key": "property/6767906449165595/019d7912-63c3-7533-9550-759b767170ec.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/legacy-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14914461338951754120&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "legacy-park",
      "poi_latitude": "35.2409368",
      "poi_longitude": "-97.4837974",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-2790-75b6-b98f-d4bb5ec6d456.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-2790-75b6-b98f-d4bb5ec6d456",
        "storage_key": "property/6767906449165595/019cfb3d-2790-75b6-b98f-d4bb5ec6d456.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe70ttXhpsocRiCGETJHP-s4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1c988bc5-5343-4771-a1b1-775f6db6ebb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Color Me Mine",
      "poi_type": "Entertainment",
      "poi_address": "1632 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Paint-your-own ceramics chain, with a studio available for walk-ins, workshops & parties.",
      "poi_long_description": "People say this painting studio offers a wide variety of ceramics and paint colors, as well as different tools for various painting techniques. They highlight the fun, relaxing, and creative experience, and the reasonable prices. They also like the friendly, helpful, and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-668d-70e0-8b86-a7cfc27fe52e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-668d-70e0-8b86-a7cfc27fe52e",
        "storage_key": "property/6767906449165595/019d7912-668d-70e0-8b86-a7cfc27fe52e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://norman.colormemine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3480454719087313852&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "color-me-mine",
      "poi_latitude": "35.2390077",
      "poi_longitude": "-97.4828895",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-364-1223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-277d-75a7-b1f7-e33c8c8261ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-277d-75a7-b1f7-e33c8c8261ca",
        "storage_key": "property/6767906449165595/019cfb3d-277d-75a7-b1f7-e33c8c8261ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd-jXp8hpsocRvAMIdCAPTTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2a39e8f-fd23-4d28-98db-ebeec923452c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "AMC Robinson Crossing 6",
      "poi_type": "Entertainment",
      "poi_address": "1300 N Interstate Dr, Norman, OK 73072, USA",
      "poi_short_description": "Chain cinema offering IMAX, Dolby Cinema, and Prime at a location with rocking seats.",
      "poi_long_description": "People say this movie theater offers comfortable reclining and heated seats, and a wide selection of snacks and drinks, including popcorn and cocktails. They also highlight the clean facilities, friendly and engaging staff, and the spacious auditoriums with plenty of legroom.\n\nOther reviews mention some seats can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-744e-716c-bf38-c3d2489feb29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-744e-716c-bf38-c3d2489feb29",
        "storage_key": "property/6767906449165595/019d7912-744e-716c-bf38-c3d2489feb29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/oklahoma-city/amc-robinson-crossing-6?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6899507102333296808&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "amc-robinson-crossing-6",
      "poi_latitude": "35.2348249",
      "poi_longitude": "-97.4886377",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-217-0531",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-8efd-729d-a43d-0cba13c79983.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-8efd-729d-a43d-0cba13c79983",
        "storage_key": "property/6767906449165595/019d7912-8efd-729d-a43d-0cba13c79983.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJp68L51ZpsocRqGDchyf5v18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_a7580625-5317-45b4-b905-c52326d896e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Get Air Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "3369 W Main St, Norman, OK 73072, USA",
      "poi_short_description": "Play place featuring trampoline courts, slam ball and dodgeball games, plus a foam pit.",
      "poi_long_description": "People say this amusement center offers a variety of trampolines, an obstacle course, a toddler play area, and a foam pit with a swing. They also highlight the clean facilities, including restrooms, water fountain, and snack room, and the friendly, helpful, and attentive staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-78c8-71e2-8b7c-1945c9916529.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-78c8-71e2-8b7c-1945c9916529",
        "storage_key": "property/6767906449165595/019d7912-78c8-71e2-8b7c-1945c9916529.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://getairsports.com/norman",
      "poi_directions_map_url": "https://maps.google.com/?cid=15431243857532982004&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "get-air-trampoline-park",
      "poi_latitude": "35.22088189999999",
      "poi_longitude": "-97.49034",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-256-1078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-277d-75a7-b1f7-e33c8c8261ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-277d-75a7-b1f7-e33c8c8261ca",
        "storage_key": "property/6767906449165595/019cfb3d-277d-75a7-b1f7-e33c8c8261ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS5ZqBQ5psocR9JKuuofKJtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_2c6e9fdc-7973-4ad2-a7b1-99f0d7ef289e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Westwood Park",
      "poi_type": "Entertainment",
      "poi_address": "2400 Westport Dr, Norman, OK 73069, USA",
      "poi_short_description": "Pool, slides, lazy river and a water playground.",
      "poi_long_description": "People say this park offers a golf course, lazy river, and water park with slides, diving boards, and a toddler area. They highlight the fun and relaxing atmosphere, and the affordable concession prices. They also like the clean facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-77ad-740d-bc1d-d738bfeafe75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-77ad-740d-bc1d-d738bfeafe75",
        "storage_key": "property/6767906449165595/019d7912-77ad-740d-bc1d-d738bfeafe75.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.normanok.gov/residents-visitors/parks-recreation/parks/westwood-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13291612059101357159&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "westwood-park",
      "poi_latitude": "35.2298346",
      "poi_longitude": "-97.4719463",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-366-5472",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-2790-75b6-b98f-d4bb5ec6d456.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-2790-75b6-b98f-d4bb5ec6d456",
        "storage_key": "property/6767906449165595/019cfb3d-2790-75b6-b98f-d4bb5ec6d456.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZTmRm5lpsocRZ-QI675Kdbg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6c4a65eb-00eb-4e09-98f9-14a54b481d87",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "Sooner Bowling Center",
      "poi_type": "Entertainment",
      "poi_address": "550 24th Ave NW, Norman, OK 73069, USA",
      "poi_short_description": "Complex offering 24 lanes with bumpers, glow-in-the-dark parties, pool tables & American eats.",
      "poi_long_description": "People say this bowling alley offers a fun experience for all ages. They also highlight the helpful and friendly staff, and the well-kept lanes.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019d7912-7ac1-706d-83ee-59ee1d09472b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-7ac1-706d-83ee-59ee1d09472b",
        "storage_key": "property/6767906449165595/019d7912-7ac1-706d-83ee-59ee1d09472b.webp",
        "width": 1242,
        "height": 699
      },
      "poi_business_url": "http://www.soonerbowl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13973678635675397072&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sooner-bowling-center",
      "poi_latitude": "35.2252718",
      "poi_longitude": "-97.4773998",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-360-3634",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-277d-75a7-b1f7-e33c8c8261ca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3d-277d-75a7-b1f7-e33c8c8261ca",
        "storage_key": "property/6767906449165595/019cfb3d-277d-75a7-b1f7-e33c8c8261ca.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfbj946FpsocR0Kvl9K567ME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_c399410a-7ccc-4f97-b3ed-3214d174c6f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "poi_name": "L. Dale Mitchell Park",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "l-dale-mitchell-park",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_48cc7330e64e47d58e299cf8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_fd1a931a23f54f358c65135e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_3fca794a685e76654a55e1bd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_bf3569f8c5c455292e593a40",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_9ea9545343853b3c38b80fe1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_58dada42ccb5efa129fc61cd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_dae2a5c78c6ec471f7fba7eb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "rating": "5",
      "name": "Katie Lynch",
      "text": "I’ve lived here over 2 years now and I absolutely love it here. Maintenance is always timely, I’ve never felt unsafe, and the location is amazing (close to so many shopping places/food places). I’ve had zero complaints since moving in. We have the townhouse layout and it’s very spacious! I highly recommend living here!!",
      "date": "2025-08-08",
      "title": "false"
    },
    {
      "id": "ec_ec02a0a20ec4aa9756795f4a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "rating": "5",
      "name": "Trish Hunt",
      "text": "Everyone here is fantastic. I feel safe living here. I never seen the police here and I’ve been here a year and a half. Apartment is nice size, nice layout just wish we had a microwave above the stove. The grounds are kept immaculate. The location is great we’re right over the bridge from 24th Street.",
      "date": "2025-02-16",
      "title": "false"
    },
    {
      "id": "ec_1b3aedf89fdb347ed09346e2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "rating": "5",
      "name": "Donna Esquer",
      "text": "Quick and friendly maintenance 😄 After living here over 6 months, I can say this place is well cared for and the office has great staff, it’s safe and a great location. Our neighbors are great. Never had any trouble and very low on crime. Only see the police driving around. I highly recommend this complex.",
      "date": "2025-09-26",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e08329e0-0993-45be-bcbd-3544cd3615c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-e632-763c-b3e2-2977994d1315.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360\rc2\badegree virtual tour of community pool and lounge area.",
        "public_id": "019cfb3d-e632-763c-b3e2-2977994d1315",
        "storage_key": "property/6767906449165595/019cfb3d-e632-763c-b3e2-2977994d1315.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Cimarron Trails Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f69c2e704adcd5d324f2fdb"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-26ed-7689-acc9-e621189c0f52",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "cimarron-trails-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595"
    },
    {
      "lead_collector_id": "019cf79e-2760-7073-b1ea-4a2732e065df",
      "lead_source": "LANDING_PAGE",
      "name": "cimarron-trails-apts.",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-norman-ok",
      "search_query": "luxury apartments with pool Norman OK",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Norman, OK",
      "h2_subtitle": "Discover luxury living at its finest at Cimarron Trails Apts. Enjoy a lavish lifestyle with our resort-style pool and top-notch amenities in Norman, OK.",
      "page_copy": "Experience the pinnacle of luxury at Cimarron Trails Apts., where our luxury apartments with pool in Norman, OK, redefine modern living. Nestled in a picturesque setting, Cimarron Trails offers spacious one, two, and three-bedroom floor plans designed with your comfort in mind. Our residents enjoy exclusive access to resort-style amenities, including a sparkling pool that invites relaxation and social gatherings.\n\nLiving at Cimarron Trails, you’ll find everything you need to elevate your everyday life. Besides our exquisite pool, benefit from our picnic area, tennis court, and lush walking trails. Perfectly located in Norman, OK, you'll experience the convenience of vibrant local attractions and serene community life. Ready to explore the lifestyle you deserve? Check availability or schedule a tour now.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
      "featured_image_media": {
        "alt_text": "Spacious community lounge with a coffee bar, fireplace, and seating area.",
        "public_id": "019cfb3d-037c-748a-96b8-8e4284865888",
        "storage_key": "property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool - Norman, OK",
      "seo_description": "Explore luxury living at Cimarron Trails Apts. in Norman, OK. Enjoy a sparkling pool and premium amenities. Book your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "generator",
      "page_item_url": "norman-apartments-with-in-unit-laundry",
      "search_query": "Norman apartments with in unit laundry",
      "category": "Amenity",
      "h1_title": "Norman Apartments with In-Unit Laundry",
      "h2_subtitle": "Experience the convenience of Norman apartments with in-unit laundry at Cimarron Trails Apts. Enjoy modern living in the heart of Norman, OK.",
      "page_copy": "At Cimarron Trails Apts., discover the ease of living in Norman, OK, with our apartments featuring in-unit laundry facilities. Our spacious one, two, and three-bedroom floor plans are designed to cater to your lifestyle needs, ensuring convenience and comfort every step of the way. No more shared laundry rooms—enjoy the privacy and efficiency of doing laundry from the comfort of your own home.\n\nOur community enhances everyday life with luxurious amenities such as a refreshing pool, picnic area, and lush walking trails, all within reach of your modern Norman apartment. Located in a vibrant neighborhood, Cimarron Trails offers easy access to local dining and entertainment, making it an ideal place to call home. Discover the perfect blend of style and functionality and schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
      "featured_image_media": {
        "alt_text": "Spacious community lounge with a coffee bar, fireplace, and seating area.",
        "public_id": "019cfb3d-037c-748a-96b8-8e4284865888",
        "storage_key": "property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Norman Apartments with In-Unit Laundry",
      "seo_description": "Find Norman apartments with in-unit laundry at Cimarron Trails Apts. Enjoy modern amenities and convenience. Schedule a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-norman-ok",
      "search_query": "air conditioned apartments in Norman OK",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Norman, OK",
      "h2_subtitle": "Stay cool in our air conditioned apartments in Norman, OK. At Cimarron Trails Apts., comfort meets convenience in every home.",
      "page_copy": "Relish in the comfort of air conditioned apartments in Norman, OK, at Cimarron Trails Apts., where your comfort is our priority. Each of our thoughtfully designed one, two, and three-bedroom homes is equipped with air conditioning, providing a cool retreat during Oklahoma’s warmer months. Our community is crafted to ensure you enjoy a comfortable and relaxing environment year-round.\n\nBeyond the cool air of your apartment, enjoy a plethora of amenities including a shimmering pool, picnic area, and scenic walking trails that enhance your living experience. Nestled in a vibrant Norman, OK neighborhood, Cimarron Trails offers the perfect balance of peaceful living and an active lifestyle, with local attractions just moments away. Discover more about our air conditioned apartments today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
      "featured_image_media": {
        "alt_text": "Spacious community lounge with a coffee bar, fireplace, and seating area.",
        "public_id": "019cfb3d-037c-748a-96b8-8e4284865888",
        "storage_key": "property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments - Norman, OK",
      "seo_description": "Stay comfortable in air conditioned apartments at Cimarron Trails Apts. in Norman, OK. Discover top-notch amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "generator",
      "page_item_url": "apartments-with-dishwasher-norman-ok",
      "search_query": "apartments with dishwasher Norman OK",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Norman, OK",
      "h2_subtitle": "Find convenience with apartments with a dishwasher in Norman, OK. Enjoy modern living at Cimarron Trails Apts. with top-tier amenities.",
      "page_copy": "Enjoy modern convenience at Cimarron Trails Apts., where our Norman, OK apartments are equipped with dishwashers to make kitchen cleanup a breeze. Choose from our spacious one, two, and three-bedroom layouts, each designed with contemporary features and finishes that cater to your lifestyle. With a dishwasher in every unit, you can spend less time on chores and more time enjoying your beautiful home.\n\nLiving at Cimarron Trails means experiencing convenience at every turn. Beyond the in-home perks like a dishwasher, take advantage of our community amenities. Dive into our refreshing pool, unwind in our picnic area, or explore the lush walking trails. Situated in vibrant Norman, OK, you're close to dining, shopping, and entertainment options, all while enjoying the comfort of a well-appointed apartment. Schedule your visit today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
      "featured_image_media": {
        "alt_text": "Spacious community lounge with a coffee bar, fireplace, and seating area.",
        "public_id": "019cfb3d-037c-748a-96b8-8e4284865888",
        "storage_key": "property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher - Norman, OK",
      "seo_description": "Discover apartments with a dishwasher at Cimarron Trails Apts. in Norman, OK. Enjoy modern living with top amenities and prime location. Book a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-walking-trails-norman",
      "search_query": "pet friendly apartments with walking trails Norman",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Walking Trails",
      "h2_subtitle": "Explore pet friendly apartments with walking trails in Norman at Cimarron Trails Apts. Perfect for you and your furry friend.",
      "page_copy": "Discover the ideal living environment for you and your pet at Cimarron Trails Apts., offering pet friendly apartments with walking trails in Norman. Our community is designed with pet owners in mind, featuring spacious one, two, and three-bedroom layouts that provide plenty of room for you and your furry companions. With lush walking trails just steps from your door, you and your pet can enjoy daily strolls in a serene setting.\n\nCimarron Trails Apts. not only welcomes your pets but also enhances your lifestyle with a range of amenities. Enjoy a sparkling pool, a picnic area, and a convenient location that puts local attractions within easy reach. Situated in Norman, OK, our community balances nature and city living, making it a perfect place for pet lovers. Visit us today and see why our pet-friendly apartments are the ideal choice!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
      "featured_image_media": {
        "alt_text": "Spacious community lounge with a coffee bar, fireplace, and seating area.",
        "public_id": "019cfb3d-037c-748a-96b8-8e4284865888",
        "storage_key": "property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments - Norman, OK",
      "seo_description": "Enjoy pet friendly apartments with walking trails at Cimarron Trails Apts. in Norman. Perfect for you and your pets with top amenities and location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-norman-ok",
      "search_query": "one bedroom apartments norman ok",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Norman, OK",
      "h2_subtitle": "Discover cozy one bedroom apartments in Norman, OK at Cimarron Trails Apts. Enjoy modern amenities and a great community setting.",
      "page_copy": "Experience comfortable and stylish living with our one bedroom apartments in Norman, OK at Cimarron Trails Apts. Our well-designed floor plans provide the perfect blend of space and function, ideal for singles or couples looking for a welcoming home. Each apartment is equipped with modern features that enhance your everyday living experience, ensuring a cozy retreat at the end of the day.\n\nBeyond the comfort of your apartment, Cimarron Trails offers an array of amenities, from a refreshing pool and picnic area to a tennis court and lush walking trails. Located in vibrant Norman, OK, our community is nestled near local shops, dining options, and entertainment venues. Discover why our one bedroom apartments are the perfect place to call home by scheduling a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
      "featured_image_media": {
        "alt_text": "Spacious community lounge with a coffee bar, fireplace, and seating area.",
        "public_id": "019cfb3d-037c-748a-96b8-8e4284865888",
        "storage_key": "property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments - Norman, OK",
      "seo_description": "Explore one bedroom apartments at Cimarron Trails Apts. in Norman, OK. Enjoy modern amenities and a welcoming community. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-near-rock-creek-trail",
      "search_query": "two bedroom apartments near rock creek trail",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near Rock Creek Trail",
      "h2_subtitle": "Discover spacious two bedroom apartments near Rock Creek Trail at Cimarron Trails Apts. Enjoy the ideal blend of comfort and convenience.",
      "page_copy": "Cimarron Trails Apts. offers spacious two bedroom apartments near Rock Creek Trail, perfect for those seeking both comfort and convenience in Norman. Our thoughtfully designed floor plans provide ample space for families, roommates, or those who enjoy having extra room. Each apartment combines functionality with style, enhanced by modern amenities like a dishwasher, making daily chores a breeze.\n\nOur prime location near Rock Creek Trail allows residents to enjoy scenic walks and outdoor activities right at their doorstep. In addition to this natural beauty, Cimarron Trails features community amenities such as a sparkling pool, tennis court, and picnic area. Enjoy easy access to local dining, shopping, and entertainment options in Norman. Visit Cimarron Trails Apts. today to discover your ideal two bedroom home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
      "featured_image_media": {
        "alt_text": "Spacious community lounge with a coffee bar, fireplace, and seating area.",
        "public_id": "019cfb3d-037c-748a-96b8-8e4284865888",
        "storage_key": "property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments - Rock Creek Trail",
      "seo_description": "Find two bedroom apartments near Rock Creek Trail at Cimarron Trails Apts. Enjoy spacious living with top amenities in a convenient Norman location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165595",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-cleveland-county",
      "search_query": "three bedroom apartments in cleveland county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Cleveland County",
      "h2_subtitle": "Explore spacious three bedroom apartments in Cleveland County at Cimarron Trails Apts. Perfect for families seeking comfort and style.",
      "page_copy": "Discover the ultimate in spacious living with our three bedroom apartments in Cleveland County, located at Cimarron Trails Apts. Perfect for families or those seeking ample space, our three-bedroom floor plans offer generous layouts designed to accommodate your lifestyle. Modern kitchen amenities, including a dishwasher, facilitate effortless meal prep and cleanup in these inviting homes.\n\nSituated in the heart of Cleveland County, our community combines suburban tranquility with access to Norman’s vibrant culture and activities. Enjoy onsite amenities like a refreshing pool, tennis court, and picnic areas, which enhance the community feel. Plus, with lush walking trails nearby, you can relish the outdoors whenever you wish. Discover your ideal family home at Cimarron Trails Apts. today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
      "featured_image_media": {
        "alt_text": "Spacious community lounge with a coffee bar, fireplace, and seating area.",
        "public_id": "019cfb3d-037c-748a-96b8-8e4284865888",
        "storage_key": "property/6767906449165595/019cfb3d-037c-748a-96b8-8e4284865888.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments - Cleveland County",
      "seo_description": "Explore three bedroom apartments at Cimarron Trails Apts. in Cleveland County. Ideal for families, with modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5158"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-1DSQQ6F318"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041152014"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/cimarron-trails/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-M9TLZKFF"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165595/019d1bd7-8dd8-7229-814f-aa1e838a6720.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "6c5d1227-127f-4b76-ba07-2d54fed7609f"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-570-2991"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64ac4ec6764e8045e6efe968"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IndSZEJRR3VZVFZyZ2IxNDVkSmtzemc9PSIsInZhbHVlIjoidG5OTG84ZHpjWFJoMlRRUVJlL0lHUT09IiwibWFjIjoiMWQyOWJjMjViZmY0OTg0ZjlkM2ZjOTI5NjU0MTFlYzZlZmMzNDZhMTdmNGY1NjAyYTYwYTQwOTRkYzgwYTAxZiJ9"
    }
  ],
  "custom_qb_id": "5158",
  "custom_ga4_id": "G-1DSQQ6F318",
  "custom_repli_id": "10041152014",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/cimarron-trails/register/",
  "custom_google_gtm_id": "GTM-M9TLZKFF",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165595/019d1bd7-8dd8-7229-814f-aa1e838a6720.pdf",
  "custom_rentgrata_property_id": "6c5d1227-127f-4b76-ba07-2d54fed7609f",
  "custom_ppc_tracking_phone_number": "800-570-2991",
  "custom_residentboost_apartment_id": "64ac4ec6764e8045e6efe968",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IndSZEJRR3VZVFZyZ2IxNDVkSmtzemc9PSIsInZhbHVlIjoidG5OTG84ZHpjWFJoMlRRUVJlL0lHUT09IiwibWFjIjoiMWQyOWJjMjViZmY0OTg0ZjlkM2ZjOTI5NjU0MTFlYzZlZmMzNDZhMTdmNGY1NjAyYTYwYTQwOTRkYzgwYTAxZiJ9"
};

export const generatedAt = '2026-08-27T21:38:50.655Z';
